//CAMBIOS HASTA ACA VERSION 1.0 VAMOS ATRABAJAR EL REFRESH AUTOMATICO, Y ATENEMOS TIMER SOLO VAMOS AFINAR, BOTN YA FUNCIONA
import React, {useState, useContext, useEffect, useRef, useMemo} from "react";

import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {Row, Col, Card, CardBody, Spinner} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import ReactDOM from 'react-dom';
import "moment-timezone";
import AgendaFlotantePantallas from './AgendaCitasflotantes/AgendaFlotantePantallas';
import AgendaFlotanteInformeGeneral from './AgendaCitasflotantes/AgendaFlotanteInformeGeneral';
// import { Alert, Space } from "antd";
// import Select from "react-select";

import WindowedSelect from "react-windowed-select";
import SelectPacientesPaginado from "../components/SelectAsyncPaginate";
import useWindowDimensions from "../hooks/dimensionsHook";

// Librería para el calendario
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";

import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/daygrid/main.css";
// import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import listPlugin from "@fullcalendar/list";

// import DayjsUtils from "@date-io/dayjs";
// import "dayjs/locale/es";

import DrawerHistoricoCitas from "./DrawerHistoricoCitas";

// Imports de Context necesarios
import CalendarioContext from "../context/Calendario/CalendarioContext";
import AuthContext from "../context/Auth/AuthContext";
import EspaciosAtencionContext from "../context/EspaciosAtencion/EspaciosAtencionContext";
import PacientesContext from "../context/Pacientes/PacientesContext";
import CatTipoCitaContext from "../context/CatTipoCita/CatTipoCitaContext";
import MedicosContext from "../context/Medicos/MedicosContext";
import AseguradorasContext from "../context/Aseguradoras/AseguradorasContext";  
//Utils
import formatDate from "../utils/formatDate";

import {opcionesSelectPacientes} from "../config/configOpcionesSelect";

export default function Calendario(props) {
    // const calendarComponentRef = React.createRef();
    moment.tz.setDefault("America/Mexico_City");
    const calendarComponentRef = useRef(React.createRef());
    const guardandoCitaRef = useRef(false);

    const {width} = useWindowDimensions();

    // Se obtienen métodos y variables de los contextos
    const authContext = useContext(AuthContext);
    const {usuario} = authContext;

    //ACCESO AL ESTADO GLOBAL - Calendario
    const ctxCalendario = useContext(CalendarioContext);
    const {
        citas,
        listarCitas,
        fetchAndApplyCitasChanges,
        filtroCitasEspacios,
        setFiltroCitasEspacios,
        filtroCitasPacientes,
        setFiltroCitasPacientes,
        filtroCitasAseguradoras,
        setFiltroCitasAseguradoras,
        uploadCita,
        deleteCita,
        exportAgenda,
        exportAgendaPorDia,
        listarCitasPaciente,
        traerCita,
        patchCitaEnLista ,
    } = ctxCalendario;

    const ctxMedicos = useContext(MedicosContext);
    const {listarMedicos, medicos} = ctxMedicos;

    //ACCESO AL ESTADO GLOBAL - Espacios Atencion
    const ctxEspAtn = useContext(EspaciosAtencionContext);
    const {espaciosAtencionAgenda, listarEspaciosAtencionAgenda} = ctxEspAtn;

    const pacientesContext = useContext(PacientesContext);
    const {setIdCatPacienteSeleccionado, pacientes, listarPacientesActivos, loadPacientesSelect} = pacientesContext;

    const catTipoCitaContext = useContext(CatTipoCitaContext);
    const {tipoCitas, listarCatTipoCitas} = catTipoCitaContext;

    const ctxAseguradora = useContext(AseguradorasContext);
    const { aseguradoras, listarAseguradoras } = ctxAseguradora;

    // const [errorFetch, setErrorFetch] = useState({ show: false, description: "" });
    const [horarioMinimoCalendario, setHorarioMinimoCalendario] = useState("06:00:00");

    const tienePermisoAseguradoras = usuario && usuario.authorities.includes("ROLE_ASEGURADORAS");

    const esMedico = usuario.idCatMedico != null  && usuario.authorities.includes("ROLE_MEDICO")

    const esMedicoNoAdministrador = (usuario.idCatMedico != null  && !usuario.authorities.includes("ROLE_ADMIN_SISTEMA")) ||
                                     usuario.authorities.includes("ROLE_ASISTENTE");

    const esAsistente =  usuario.authorities.includes("ROLE_ASISTENTE");

    const esFarmacia =  usuario.authorities.includes("ROLE_FARMACIA");

    const banMostrarObjetos = (
        (usuario.authorities.includes("ROLE_AGENDA") && !usuario.authorities.includes("ROLE_MEDICO")) ||
        usuario.authorities.includes("ROLE_ADMIN_SISTEMA")
    )

    const banCrearCitas = ( (usuario.authorities.includes("ROLE_AGENDA") && usuario.authorities.includes("ROLE_RECEPCION") ) || 
                            (usuario.authorities.includes("ROLE_MEDICO") && usuario.idCatMedico != null )                    ||
                            ( usuario.authorities.includes("ROLE_ASISTENTE")                          )                      ||
                             usuario.authorities.includes("ROLE_ADMIN_SISTEMA")
                          );
  
    const banCrearPaciente = (
        usuario.authorities.includes("ROLE_RECEPCION") ||
        (usuario.authorities.includes("ROLE_MEDICO") && usuario.idCatMedico != null) ||
        usuario.authorities.includes("ROLE_ADMIN_SISTEMA")
    );                           

    const esMedicoConRoleAgenda = usuario.authorities.includes("ROLE_AGENDA") 
                                   && usuario.authorities.includes("ROLE_MEDICO");

    const banOcultarCalendario = (usuario.authorities.includes("ROLE_MEDICO") && (usuario.idCatMedico == null )
                                 && !usuario.authorities.includes("ROLE_ADMIN_SISTEMA") 
                                 );


    const banImprimiragenda = ( ( usuario.authorities.includes("ROLE_AGENDA") && usuario.authorities.includes("ROLE_RECEPCION") ) || 
                                ( usuario.authorities.includes("ROLE_AGENDA")                          )                          ||
                                ( usuario.authorities.includes("ROLE_ASISTENTE")                          )                       ||
                                ( usuario.authorities.includes("ROLE_MEDICO") && usuario.idCatMedico != null                    ) ||
                                  usuario.authorities.includes("ROLE_ADMIN_SISTEMA") 
                              );                               

    const sweetAlertDefault = {
        confirm_alert_eliminar_cita: false,
        confirm_alert_cita: false,
        confirm_alert_cita_no_autorizado: false,
        confirm_imprimir_agenda: false,
        confirm_historico_paciente: false,
        confirm_exponer_agenda : false,
        confirm_exponer_agendaGeneral : false,
        editar: false,
        success_dlg: false,
        error_dlg: false,
        redirect: false,
        path: "",
        dynamic_title: "",
        dynamic_description: "",
    };

    const [UISweetAlert, setUISweetAlert] = useState(sweetAlertDefault);

    const [loading, setLoading] = useState(false);
    const [comentarioPaciente, setComentarioPaciente] = useState(false);

    // Variable State para guardar el paciente de la cita seleccionada
    const [pacienteDeCitaSeleccionada, setPacienteDeCitaSeleccionada] = useState(null);
    //const [nombrePaciente, setNombrePaciente] = useState(null);
    //const [tieneAseguradora, setTieneAseguradora] = useState(false);

    const [citasPaciente, setCitasPaciente] = useState([]);
    const [infoCalGlobal, setInfoCalGlobal] = useState([]);

    const [comentarioAseguradoraOriginal, setComentarioAseguradoraOriginal] = useState("");
    const [comentarioFarmaciaOriginal, setComentarioFarmaciaOriginal] = useState("");
    const [comentarioTratamientoOriginal, setComentarioTratamientoOriginal] = useState("");
    const [comentarioRecepcionOriginal, setComentarioRecepcionOriginal] = useState("");    
    const [paciente,setPaciente] = useState("");    
    const [tipoCitaId,setTipoCitaId] = useState(0);   
    const [espacioOriginal,setEspacioOriginal] = useState(0);    
    const [consultorio,setConsultorio] = useState("");    
    const [fechaInicio,setFechaInicio] = useState(""); 
    const [fechafinal,setFechaFinal] = useState(""); 
    const [pacienteIdOriginal,setPacienteIdOriginal] = useState(0); 
    const [existenFiltros,setExistenFiltros] = useState(false); 
    // eslint-disable-next-line
    // const [espaciosAtencionIniciales, setEspaciosAtencionIniciales] = useState(seleccionarEspaciosAtencionDefault());

    let today = new Date();
 
    let delayTime = 2000;

    const [fechaActual, setFechaActual] = useState(today);
    const [, setDisabledEditar] = useState(false);

    const [opcionesExtras, setOpcionesExtras] = useState({
        seleccionarTodosEspacios: (esAsistente?false:!esMedicoNoAdministrador),
        seleccionarTodosPacientes: (esAsistente?false:!esMedicoNoAdministrador),
        porAseguradora: false,
    });
  
    const [filtrosImpresion, setFiltrosImpresion] = useState({
        fechaImpresion: "",
        porDia: false,
        incluirTratamientos: true,
        incluirCitas: true,
    });

    // const [listarPacientesDone, setListarPacientesDone] = useState(false);
    // eslint-disable-next-line no-unused-vars

    const [datosPaciente, setDatosPaciente] = useState({});

    const [pacienteSeleccionadoHistorico, setPacienteSeleccionadoHistorico] = useState(null);

    const [opcionesEspacios, setOpcionesEspacios] = useState({}); 

    const [opcionesPacientes, setOpcionesPacientes] = useState([]);
    const [opcionesAseguradoras, setOpcionesAseguradoras] = useState([]);
    const [nombrePacienteGlobal, setNombrePacienteGlobal] = useState(null);

    const[confirmaSobreEscribirCita,setConfirmaSobreEscribirCita] = useState(false)
    const[mensajeSobreEscribirCita,setMensajeSobreEscribirCita] = useState("")
    const[ignorarBack,setIgnorarBack] = useState(false)

    // 5 minutos * 60000 = 300000 
    // 30 minutos * 60000 = 1800000
    // eslint-disable-next-line
    const [tiempoCita, setTiempoCita] = useState(1800000);

    const newStartDate = new Date(); 
    const startDate = formatDate(newStartDate, true);
    const newEndDate = new Date(new Date().getTime() + tiempoCita);
    const endDate = formatDate(newEndDate, true);

    const [citaSeleccionada, setCitaSeleccionada] = useState({
        start: startDate,
        end: endDate,
        todoDia: false, 
    });

    const buildNuevaCitaState = (custom = {}) => ({
        id: null,
        title: "",
        start: formatDate(new Date(), true),
        end: formatDate(new Date(new Date().getTime() + tiempoCita), true),
        todoDia: false,
        espacio: "",
        tipoEspacio: null,
        paciente: null,
        comentarioRecepcion: "",
        idCatTipoCita: null,
        comentarioTratamiento: "",
        comentarioFarmacia: "",
        comentarioAseguradora: "",
        nombrePaciente: null,
        consultorio: "",
        description: "",
        idCatMedico: null,
        tieneAseguradora: false,
        ...custom,
    });
    const puedeEditarComentarioAseguradora = tienePermisoAseguradoras && citaSeleccionada?.tieneAseguradora === true;


    //ACA ESTAN LAS VARIABLES QUE CONTROLAN EL TOOLTIP DE LAS CITAS EN LA AGENDA
    const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const [showTooltip, setShowTooltip] = useState(false);
    const calendarWrapperRef = useRef(null);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const [mostrarFinDeSemana, setMostrarFinDeSemana] = useState(false);

    // ****************************   VARIABLES QUE CONTROLAN EL AUTOREFRESH
    const [pausa, setPausa] = useState(false);
    const pausaRef = useRef(false);
    useEffect(() => { pausaRef.current = pausa; }, [pausa]);

    // evita solapamientos
    const refreshInFlightRef = useRef(false);
    const REFRESH_INTERVAL_MS = 90000;
    const refreshFnRef = useRef(async () => {});
    
    const filtrosRef = useRef({
        viewStart: null,
        viewEnd: null,
        espaciosVo: [],
        pacientesVo: [],
        aseguradorasVo: [],
        todosEspacios: false,
        todosPacientes: false,
        porAseguradora: false,
        incluirTratamientos: false,
        incluirCitas: false,
      });
    // ********************************************** FIN DE AREA AUTO REFRESH

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const delay = async (ms) => {
        return new Promise((resolve) => 
            setTimeout(resolve, ms));
    }; 

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const espaciosFiltrados = espaciosAtencionAgenda.filter((espacio) => {
        if (existenFiltros && filtroCitasEspacios){
            let encontrado = false;
            filtroCitasEspacios.map((filtro) =>{
                if(filtro.idEspacio == espacio.idEspacio){
                    encontrado = true;
                }
            })
            if(encontrado){
                return espacio;
            }
        }else{
            if(esAsistente){
                if (espacio.idAsistente == usuario.idCatUsuario){
                    return espacio;
                }
            }else{
                return espacio.idCatMedico == usuario.idCatMedico;
            }
        }       
    });
   
    const [espaciosAtencionDefault, setEspaciosAtencionDefault] = useState(espaciosFiltrados);


        const openNewWindowGeneral = (datos) => {
            // Abre una nueva pestaña
            const newWindow = window.open('', '_blank'); // Abre una nueva pestaña
          
            // Contenido HTML básico para la nueva pestaña
            const content = `
              <html>
              <head>
                  <title>Componente en nueva pestaña</title>
                  <style>
                  body {
                      font-family: Arial, sans-serif;
                      background-color: #D3D3D3;
                      margin: 0;
                      padding: 20px;
                  }
                  h1 {
                      color: #333;
                  }
                  </style>
              </head>
              <body>
                  <div id="root"></div>
              </body>
              </html>
            `;
          
            // Escribir el contenido HTML en la nueva pestaña
            newWindow.document.write(content);
            newWindow.document.close();
          
            // Aquí puedes establecer los datos que necesites para tu componente
            datos.porDia = true;
            datos.incluirCitas = true;
            datos.incluirTratamientos = true;
          
            // Usar ReactDOM para renderizar el componente React en la nueva pestaña
            ReactDOM.render(
              <AgendaFlotanteInformeGeneral data={datos} />,
              newWindow.document.getElementById('root')
            );
          };

    const openNewWindow = (datos) => {
      // Abre una nueva ventana
        const newWindow = window.open('', 'Ventana2', 'width=1600,height=900,location=no,menubar=no');
        // Contenido HTML básico
        //background-color: #8A2BE2; /* Color de fondo */
        const content = `
            <html>
            <head>
                <title>Ventana con fondo de color</title>
                <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #D3D3D3;
                    margin: 0;
                    padding: 20px;
                }
                h1 {
                    color: #333;
                }
                </style>
            </head>
            </html>
        `;
        newWindow.document.write(content);
        // Rendirizar el informe en la nueva ventana
        newWindow.document.body.innerHTML = `<div  id="Pantallas"></div>`;
        // Usamos ReactDOM para renderizar el componente React en la nueva ventana
        // Necesitamos acceder al contenedor de la nueva ventana
        import('react-dom').then(({ render }) => {
            datos.porDia = true;
            datos.incluirCitas = true;
            datos.incluirTratamientos = true;
            // Establecer el tamaño de la ventana emergente (por ejemplo, 2500x1500)
            const windowWidth = 1600;
            const windowHeight = 900;
            //render(<Report width = {2500} data={datos} />, newWindow.document.getElementById('report'));
            render(<AgendaFlotantePantallas width={windowWidth} height={windowHeight} data={datos} />, newWindow.document.getElementById('Pantallas'));
        });
      
    };

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    useEffect(() => {
        const fetchCatTipoCitas = async () => {
            const tipoCatCitas = await listarCatTipoCitas();
            return tipoCatCitas;
        };

        const fetchPacientesActivos = async () => {
            // setUISweetAlert({
            //   ...UISweetAlert,
            //   dynamic_description: "Cargando pacientes activos",
            // });
            // setLoading(true);
            try {
                const pacientesA = await listarPacientesActivos();
                // setLoading(false);
                // setErrorFetch({ show: true, description: "Se cargaron los pacientes correctamente" });
                return pacientesA;
            } catch (error) {
                // setUISweetAlert({
                //   ...UISweetAlert,
                //   error_dlg: true,
                //   dynamic_description: "Error al cargar los pacientes del catálogo",
                // });
                // setLoading(false);
            }
        };

        const fetchMedicos = async () => {
            const medicosActivos = await listarMedicos();
            return medicosActivos;
        };
        listarAseguradoras();
        fetchCatTipoCitas();
        fetchPacientesActivos();
        fetchMedicos();
    }, []);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const nuevaCitaFechaSeleccionada = async (arg) => {
        // 2018-06-14T00:00
        const newStartDate = formatDate(arg.date, false);
        const newEndDate = formatDate(new Date(arg.date.getTime() + tiempoCita), false);
        //setNombrePaciente(null);
        setComentarioPaciente("")

        setPacienteDeCitaSeleccionada(null);
        if (usuario && esMedicoNoAdministrador) {
            if (espaciosAtencionDefault && espaciosAtencionDefault.length > 0) {
                LimpiarDatos();
                setCitaSeleccionada(
                    buildNuevaCitaState({
                        start: newStartDate,
                        end: newEndDate,
                    })
                );
            }
        } else {
            LimpiarDatos();
            setCitaSeleccionada(
                buildNuevaCitaState({
                    start: newStartDate,
                    end: newEndDate,
                })
            );
        }

        setDisabledEditar(false);
        setAutoPause(true);
        setUISweetAlert({
            ...sweetAlertDefault,
            confirm_alert_cita: true,
        });
    };

// Requiere desde el contexto: traerCita, patchCitaEnLista
// const { traerCita, patchCitaEnLista } = useContext(CalendarioContext);
    function toInputDateTimeLocal(value) {
        const d = value instanceof Date ? value : new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const yyyy = d.getFullYear();
        const MM   = pad(d.getMonth() + 1);
        const dd   = pad(d.getDate());
        const HH   = pad(d.getHours());     // HORA LOCAL
        const mm   = pad(d.getMinutes());   // MINUTO LOCAL
        return `${yyyy}-${MM}-${dd}T${HH}:${mm}`; // SIN 'Z' NI OFFSET
    }
    
    
    // ✅ Para <input type="date"> (cuando todoDia = true)
    function toInputDateLocal(value) {
        const d = value instanceof Date ? value : new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const yyyy = d.getFullYear();
        const MM   = pad(d.getMonth() + 1);
        const dd   = pad(d.getDate());
        return `${yyyy}-${MM}-${dd}`;
    }

    function normalizeComparableDate(value, todoDia = false) {
        if (!value) return "";
        if (todoDia) {
            if (typeof value === "string") {
                if (value.includes("T")) {
                    return value.split("T")[0];
                }
                if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                    return value;
                }
            }
            return toInputDateLocal(value);
        }

        const d = value instanceof Date ? value : new Date(value);
        return isNaN(d.getTime()) ? "" : String(d.getTime());
    }

    function areDatesEquivalent(valueA, valueB, todoDia = false) {
        return normalizeComparableDate(valueA, todoDia) === normalizeComparableDate(valueB, todoDia);
    }

    function appendComentarioBackendConCaptura(backendComentario, originalComentario, capturaComentario) {
        const backend = (backendComentario ?? "").trim();
        const original = (originalComentario ?? "").trim();
        const captura = (capturaComentario ?? "").trim();

        let aporte = "";
        if (captura && captura !== original) {
            if (original && captura.startsWith(original)) {
                aporte = captura.slice(original.length).trim();
            } else {
                aporte = captura;
            }
        }

        if (!aporte) return backend;
        if (!backend) return aporte;
        if (backend.includes(aporte)) return backend;
        return `${backend}\n${aporte}`;
    }

    function aplicarCitaEnFormulario(citaBase, comentariosOverride = null) {
        if (!citaBase) return;

        const todoDia = !!citaBase.extendedProps?.todoDia;
        const startDateCita = todoDia
            ? toInputDateLocal(citaBase.start)
            : toInputDateTimeLocal(citaBase.start);

        const endDateCita = todoDia
            ? toInputDateLocal(citaBase.end)
            : toInputDateTimeLocal(citaBase.end);

        setDisabledEditar(new Date(citaBase.start) >= new Date() ? true : false);
        filterPacienteCitaSeleccionada(citaBase.extendedProps?.paciente);

        const comentariosPacienteLocal =
            TraeComentariosPaciente(citaBase.extendedProps?.paciente) ?? "Sin comentarios";
        setComentarioPaciente(comentariosPacienteLocal);

        const comentarioRecepcionBackend = citaBase.extendedProps?.comentarioRecepcion ?? "";
        const comentarioTratamientoBackend = citaBase.extendedProps?.comentarioTratamiento ?? "";
        const comentarioFarmaciaBackend = citaBase.extendedProps?.comentarioFarmacia ?? "";
        const comentarioAseguradoraBackend = citaBase.extendedProps?.comentarioAseguradora ?? "";

        setComentarioRecepcionOriginal(comentarioRecepcionBackend);
        setComentarioTratamientoOriginal(comentarioTratamientoBackend);
        setComentarioFarmaciaOriginal(comentarioFarmaciaBackend);
        setComentarioAseguradoraOriginal(comentarioAseguradoraBackend);

        setPaciente(citaBase.extendedProps?.nombrePaciente || "");
        setTipoCitaId(citaBase.extendedProps?.idCatTipoCita || null);
        setEspacioOriginal(citaBase.extendedProps?.espacio || null);
        setConsultorio(citaBase.consultorio || "SIN ASIGNAR");
        setFechaInicio(startDateCita);
        setFechaFinal(endDateCita);
        setPacienteIdOriginal(citaBase.extendedProps?.paciente || 0);

        setCitaSeleccionada({
            id: citaBase.id,
            updatedAt: citaBase.updatedAt ?? null,
            title: citaBase.title,
            description: citaBase.description,
            consultorio: citaBase.consultorio,
            horaInicioStr: citaBase.horaInicioStr,
            horaFinStr: citaBase.horaFinStr,
            start: startDateCita,
            end: endDateCita,
            todoDia,
            espacio: citaBase.extendedProps?.espacio,
            tipoEspacio: citaBase.extendedProps?.tipoEspacio,
            paciente: citaBase.extendedProps?.paciente,
            nombrePaciente: citaBase.extendedProps?.nombrePaciente,
            comentarioRecepcion:
                comentariosOverride?.comentarioRecepcion ?? comentarioRecepcionBackend,
            comentarioTratamiento:
                comentariosOverride?.comentarioTratamiento ?? comentarioTratamientoBackend,
            comentarioFarmacia:
                comentariosOverride?.comentarioFarmacia ?? comentarioFarmaciaBackend,
            comentarioAseguradora:
                comentariosOverride?.comentarioAseguradora ?? comentarioAseguradoraBackend,
            tieneAseguradora: citaBase.extendedProps?.tieneAseguradora,
            idCatTipoCita: citaBase.extendedProps?.idCatTipoCita,
            idCatMedico: citaBase.extendedProps?.idCatMedico ?? null,
            className: citaBase.extendedProps?.color || "font-bold bg-purple",
        });
    }

    const recargarCitaPorConflictoComentarios = async () => {
        const idCita = citaSeleccionada?.id;
        if (!idCita) {
            setConfirmaSobreEscribirCita(false);
            return;
        }

        setLoading(true);
        try {
            const citaFresh = await traerCita(idCita).catch(() => null);
            if (!citaFresh || citaFresh?.eliminada === true) {
                setConfirmaSobreEscribirCita(false);
                setAutoPause(false);
                setUISweetAlert({
                    ...sweetAlertDefault,
                    success_dlg: true,
                    dynamic_title: "Cita no disponible",
                    dynamic_description:
                        "La cita fue eliminada o ya no existe. La agenda se actualizara.",
                });
                return;
            }

            const comentariosFusionados = {
                comentarioRecepcion: appendComentarioBackendConCaptura(
                    citaFresh.extendedProps?.comentarioRecepcion,
                    comentarioRecepcionOriginal,
                    citaSeleccionada.comentarioRecepcion
                ),
                comentarioTratamiento: appendComentarioBackendConCaptura(
                    citaFresh.extendedProps?.comentarioTratamiento,
                    comentarioTratamientoOriginal,
                    citaSeleccionada.comentarioTratamiento
                ),
                comentarioFarmacia: appendComentarioBackendConCaptura(
                    citaFresh.extendedProps?.comentarioFarmacia,
                    comentarioFarmaciaOriginal,
                    citaSeleccionada.comentarioFarmacia
                ),
                comentarioAseguradora: appendComentarioBackendConCaptura(
                    citaFresh.extendedProps?.comentarioAseguradora,
                    comentarioAseguradoraOriginal,
                    citaSeleccionada.comentarioAseguradora
                ),
            };

            const citaFusionada = {
                ...citaFresh,
                extendedProps: {
                    ...(citaFresh.extendedProps || {}),
                    ...comentariosFusionados,
                },
            };

            patchCitaEnLista(citaFusionada);
            aplicarCitaEnFormulario(citaFresh, comentariosFusionados);
            setConfirmaSobreEscribirCita(false);
            setAutoPause(true);
        } finally {
            setLoading(false);
        }
    };
    const editCitaConfirm = async (env) => {
        setLoading(true);
        const idCita = env?.event?.id;
      
        try {
          // 1) Traer la cita más reciente
          let citaFresh = null;
          try {
            citaFresh = await traerCita(idCita);
          } catch (err) {
            // Si el backend tira 404 u otro error, tratamos como "no existe"
            citaFresh = null;
          }
      
          // 2) Si NO existe: avisar y recuperar UI sin pausar el timer
          if (!citaFresh || citaFresh?.eliminada === true) {
            setUISweetAlert({
              ...sweetAlertDefault,
              success_dlg: true,
              dynamic_title: "Cita no disponible",
              dynamic_description:
                "Esta cita ya no existe (fue eliminada en otra sesión). La agenda se actualizará.",
            });
      
            // Limpia localmente: refresco incremental rápido para sacar el evento
            try {
              const { viewStart, viewEnd } = getViewRange?.() || {};
              await fetchAndApplyCitasChanges(
                {
                  viewStart,
                  viewEnd,
                  limit: 300,
                  espacios:
                    esAsistente
                      ? espaciosAtencionDefault
                      : (usuario?.idCatMedico ? espaciosAtencionDefault : filtroCitasEspacios),
                  pacientes: filtroCitasPacientes,
                  aseguradoras: opcionesAseguradoras,
                  todosEspacios: opcionesExtras.seleccionarTodosEspacios,
                  todosPacientes: opcionesExtras.seleccionarTodosPacientes,
                  porAseguradora: opcionesExtras.porAseguradora,
                },
                {
                  idsEnEdicion: new Set(),
                  updatedSince: updatedSinceRef.current,
                }
              );
            } catch (_) {
              // si el refresh falla, al menos no rompemos el flujo
            }
            setAutoPause(false);
            return; // ⬅️ No abrimos modal ni pausamos
          }
      
          // 3) Existe: sincroniza en la lista local por si cambió en servidor
          patchCitaEnLista(citaFresh);
      
          // 4) Preparar datos para el modal (tu flujo original)
          aplicarCitaEnFormulario(citaFresh);
          setCitaSeleccionada((prev) => ({
            ...prev,
            className: citaFresh.extendedProps?.color || env.event.classNames?.[0] || "font-bold bg-purple",
          }));
          setAutoPause(true);
          // 5) Abrir modal y PAUSAR timer solo en caso exitoso
          setAutoPause(true);
          setUISweetAlert({
            ...sweetAlertDefault,
            editar: true,
            confirm_alert_cita: true,
          });
        } finally {
          setLoading(false);
        }
    };
      
  
    
    const onChangeNuevaCita = (e) => {
        if (e.target.name == "espacio") 
        {
            const espacio = espaciosAtencionAgenda.filter((esp) => esp.idEspacio == e.target.value)[0];
            setCitaSeleccionada({
                ...citaSeleccionada,
                espacio: e.target.value,
                tipoEspacio: espacio.idCatTipoEspacio,
                cliente: espacio.idCatTipoEspacio == 1 ? citaSeleccionada.cliente : "",
                title: "",
            });
            return;
        }

        if (e.target.name == "idCatMedico") {
            setCitaSeleccionada({
                ...citaSeleccionada,
                idCatMedico: e.target.value,
            });
            return;
        }

        if (e.target.name == "idCatTipoCita") {
            setCitaSeleccionada({
                ...citaSeleccionada,
                idCatTipoCita: e.target.value,
            });
            return;
        }

        if (e.target.name === "todoDia") {
            let value = !citaSeleccionada.todoDia;
            let startDate = formatDate(citaSeleccionada.start, false, value);
            let endDate = value
                ? null
                : formatDate(new Date(startDate).setTime(new Date(startDate).getTime() + tiempoCita), false, false);

            setCitaSeleccionada({
                ...citaSeleccionada,
                todoDia: value,
                start: startDate,
                end: endDate,
            });
            return;
        }

        setCitaSeleccionada({
            ...citaSeleccionada,
            [e.target.name]: e.target.value,
        });
        return;
    };

    const onChangeDatosPaciente = async (e) => {
        const {name, value} = e.target;

        if(name=='nombrePaciente'){
            setNombrePacienteGlobal(value)
        }
        
        setDatosPaciente({
            ...datosPaciente,
            [name]: value,
        });
    };

    const changeFechaInicalNuevaCita = async (date) => {
        setCitaSeleccionada({
            ...citaSeleccionada,
            start: date.target.value,
        });
    };

    const changeFechaFinalNuevaCita = async (date) => {
        setCitaSeleccionada({
            ...citaSeleccionada,
            end: date.target.value,
        });
    };

    const confirmEliminarCita = async () => {
        setAutoPause(true);
        setUISweetAlert({
            ...sweetAlertDefault,
            editar: true,
            confirm_alert_cita: true,
            confirm_alert_eliminar_cita: true,
        });
    };

    const borrarCita = async () => {
        try {
            let CadenaString = "";

            CadenaString = CadenaString + ",P[" +citaSeleccionada.nombrePaciente + "]"
            CadenaString = CadenaString + ",FI[" +citaSeleccionada.start + "]"
            CadenaString = CadenaString + ",FF[" +citaSeleccionada.end + "]"

            let nuevoCadena;
            tipoCitas.filter((TipoCita) => 
            {
                    if (citaSeleccionada.idCatTipoCita == TipoCita.idCatTipoCita){
                        nuevoCadena = TipoCita.tipoCita;
                    }
            })  
            CadenaString = CadenaString+ ",TC[" + nuevoCadena + "]"                

            citaSeleccionada.logVo ={
                idUsuario: usuario.idUsuario,
                modulo: "Agenda",
                actividad:"Eliminar:ID[" + citaSeleccionada.id + "]" + CadenaString
            }

            const res = await deleteCita(citaSeleccionada);
            if (res.data.error) {
                setLoading(false);
                LimpiarDatos();
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Error en el sistema",
                });
                LimpiarDatos();
                return;
            }
            const newStartDate = new Date();
            const startDate = formatDate(newStartDate, true);
            const newEndDate = new Date(new Date().getTime() + tiempoCita);
            const endDate = formatDate(newEndDate, true);
            setCitaSeleccionada({
                start: startDate,
                end: endDate,
            });

            setDisabledEditar(false);
            LimpiarDatos();
            setUISweetAlert({
                ...sweetAlertDefault,
                success_dlg: true,
                dynamic_title: "Éxito",
                dynamic_description: "Se eliminó la cita",
            });
            setAutoPause(false);
        } catch (error) {
            setLoading(false);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_alert_cita: true,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "Ocurrió un error, por favor intentalo más tarde.",
            });
            setAutoPause(false);
        }
        setLoading(false);
        LimpiarDatos();
    };

    /* ****************************** */

    function TraePaciente(idPar){
        let retorno;
        pacientes.filter((pacientefilter) => 
        {
                if (pacientefilter.idCatPaciente == idPar){
                    retorno = pacientefilter.nombres + " " + pacientefilter.apellidoPaterno + " " + pacientefilter.apellidoMaterno;
                }
        }) 
        return retorno 
    }

    function TraePacienteNombre(idPar) {
        const paciente = pacientes.find(p => p.idCatPaciente === idPar);
        if (!paciente) return 'Paciente no encontrado';
      
        return `${paciente.nombres} ${paciente.apellidoPaterno} ${paciente.apellidoMaterno}`;
    }

    function TraeMedico(idMedico) {
        const medico = medicos.find(m => m.idCatMedico === idMedico);
        if (!medico) return 'Médico no encontrado';
      
        return `${medico.catPersona.nombres} ${medico.catPersona.apellidoPaterno} ${medico.catPersona.apellidoMaterno}`;
    }

    function TraeEspacioMedico(idEspacio) {
        const espacio = espaciosAtencionAgenda.find(e => e.idEspacio === idEspacio);
        if (!espacio) return 'Espacio no encontrado';
    
        return espacio.espacio;
    }    
      

    function TraeComentariosPaciente(idPar){
        let retorno;
        pacientes.filter((pacientefilter) => 
        {
                if (pacientefilter.idCatPaciente == idPar){
                    retorno = pacientefilter.comentario;
                }
        }) 
        return retorno 
    }

    function CitaModificada(citaBackPar) {
        let cadenaGeneral = "";
        let cadenaRetorno  = "";
      
        // ⛑️ Blindaje básico
        if (!citaBackPar || !citaBackPar.extendedProps) return "";
      
        // ====== Normalizaciones (null/undefined → "")
        const crBack = citaBackPar.extendedProps.comentarioRecepcion   ?? "";
        const caBack = citaBackPar.extendedProps.comentarioAseguradora ?? "";
        const cfBack = citaBackPar.extendedProps.comentarioFarmacia    ?? "";
        const ctBack = citaBackPar.extendedProps.comentarioTratamiento ?? "";
      
        const crOri = comentarioRecepcionOriginal   ?? "";
        const caOri = comentarioAseguradoraOriginal ?? "";
        const cfOri = comentarioFarmaciaOriginal    ?? "";
        const ctOri = comentarioTratamientoOriginal ?? "";
      
        // ====== Comparaciones de comentarios
        if (crBack !== crOri) {
          cadenaGeneral += `CR[${crBack}]`;
        }
      
        if (caBack !== caOri) {
          cadenaGeneral += `${cadenaGeneral ? "," : ""}CA[${caBack}]`;
        }
      
        if (cfBack !== cfOri) {
          cadenaGeneral += `${cadenaGeneral ? "," : ""}CF[${cfBack}]`;
        }
      
        if (ctBack !== ctOri) {
          cadenaGeneral += `${cadenaGeneral ? "," : ""}CT[${ctBack}]`;
        }
      
        // ====== Paciente (nombre)
        const pacienteTemporal = citaBackPar.extendedProps.nombrePaciente ?? "";
        const pacienteOri      = paciente ?? "";
        if (pacienteTemporal !== pacienteOri) {
          cadenaGeneral += `${cadenaGeneral ? "," : ""}P[${pacienteTemporal}]`;
        }
      
        // ====== Fechas (inicio/fin)
        const citaTodoDia = !!citaBackPar.extendedProps?.todoDia;
        const dateBackIni   = new Date(citaBackPar.start);
        if (!areDatesEquivalent(citaBackPar.start, fechaInicio, citaTodoDia)) {
          // Muestra legible (si prefieres tu toLocaleString, puedes dejarlo)
          cadenaGeneral += `${cadenaGeneral ? "," : ""}FI[${dateBackIni.toLocaleString()}]`;
        }
      
        const dateBackFin   = new Date(citaBackPar.end);
        if (!areDatesEquivalent(citaBackPar.end, fechafinal, citaTodoDia)) {
          cadenaGeneral += `${cadenaGeneral ? "," : ""}FF[${dateBackFin.toLocaleString()}]`;
        }
      
        // ====== Espacio/Médico (usa id del espacio desde extendedProps)
        const espacioBackId = citaBackPar.extendedProps.espacio ?? null; // idEspacio
        if (espacioBackId != espacioOriginal) { // espacioOriginal es el id guardado localmente
          let nuevoCadena = "";
          espaciosAtencionAgenda.forEach((esp) => {
            if (esp.idEspacio == espacioBackId) {
              nuevoCadena = esp.espacio;
            }
          });
          cadenaGeneral += `${cadenaGeneral ? "," : ""}E[${nuevoCadena}]`;
        }
      
        // ====== Tipo de Cita (compara por idCatTipoCita en extendedProps)
        const tipoCitaBackId = citaBackPar.extendedProps.idCatTipoCita ?? null;
        if (tipoCitaBackId != tipoCitaId) {
          let nuevoCadena = "";
          tipoCitas.forEach((tc) => {
            if (tc.idCatTipoCita == tipoCitaBackId) {
              nuevoCadena = tc.tipoCita;
            }
          });
          cadenaGeneral += `${cadenaGeneral ? "," : ""}TC[${nuevoCadena}]`;
        }
      
        // ====== Mensaje final
        if (cadenaGeneral.length > 0) {
          const usuario = citaBackPar.extendedProps.usuarioSolicitante ?? "otro usuario";
          cadenaRetorno =
            `La cita que está editando fue modificada por el usuario ${usuario}. ` +
            `Para evitar sobrescribir información, cancele para recargar la cita con la última versión. ` +
            `Información del cambio detectado: ${cadenaGeneral}`;
        }
      
        return cadenaRetorno;
    }
      

     function LimpiarDatos (){
        setComentarioAseguradoraOriginal("") 
        setComentarioFarmaciaOriginal("")
        setComentarioTratamientoOriginal("")
        setComentarioRecepcionOriginal("")
        setPaciente("")
        setTipoCitaId(1)  
        setEspacioOriginal(0)
        setConsultorio("")
        setFechaInicio("")
        setFechaFinal("")
        setNombrePacienteGlobal(null)
        setIgnorarBack(false);
        setConfirmaSobreEscribirCita(false);
        setPacienteIdOriginal(0);
        setCitaSeleccionada(
            buildNuevaCitaState({
                start: formatDate(new Date(), true),
                end: formatDate(new Date(new Date().getTime() + tiempoCita), true),
            })
        );
    }
 
    const checkUploadCita = async () => {
        if (guardandoCitaRef.current) {
          return;
        }

        guardandoCitaRef.current = true;
        const liberarGuardadoCita = () => {
          guardandoCitaRef.current = false;
        };

        let errorCita = false;
      
        const fail = (msg) => {
          liberarGuardadoCita();
          setUISweetAlert({
            ...sweetAlertDefault,
            confirm_alert_cita: true,
            error_dlg: true,
            dynamic_title: "Fallo",
            dynamic_description: msg,
          });
          errorCita = true;
        };
      
        // ===== Validaciones base =====
        if (!errorCita && !citaSeleccionada.title && citaSeleccionada.tipoEspacio == 2) {
          fail("Por favor, introduzca un título para la cita");
          return;
        }
        if (!errorCita && !citaSeleccionada.start) {
          fail("Por favor, introduzca una fecha de inicio");
          return;
        }
      
        const isAllDay = !!citaSeleccionada.todoDia;
        const startRaw = citaSeleccionada.start;
        const endRaw   = citaSeleccionada.end;
      
        const parseDateSafe = (v) => {
          const d = v instanceof Date ? v : new Date(v);
          return isNaN(d.getTime()) ? null : d;
        };
      
        const startDate = parseDateSafe(startRaw);
        if (!errorCita && !startDate) {
          fail("La fecha de inicio no es válida");
          return;
        }
      
        if (!isAllDay) {
          if (!errorCita && (endRaw === undefined || endRaw === null || endRaw === "")) {
            fail("Por favor, introduzca una fecha final");
            return;
          }
          const endDate = parseDateSafe(endRaw);
          if (!errorCita && !endDate) {
            fail("La fecha final no es válida");
            return;
          }
          if (!errorCita && endDate.getTime() <= startDate.getTime()) {
            fail("La fecha final debe ser mayor que la fecha inicial");
            return;
          }
        }
      
        if (!errorCita && !citaSeleccionada.espacio) {
          fail("Por favor, introduzca el espacio asignado para la cita");
          return;
        }
        if (!errorCita && !citaSeleccionada.idCatTipoCita) {
          fail("Por favor, introduzca el tipo de cita");
          return;
        }
      
        // Paciente requerido según reglas
        if (
          !errorCita &&
          citaSeleccionada.tipoEspacio == 1 &&
          !citaSeleccionada.paciente &&
          citaSeleccionada.idCatTipoCita != 11
        ) {
          fail("Por favor, introduzca el paciente para la cita");
          return;
        }
        if (
          !errorCita &&
          citaSeleccionada.tipoEspacio == 1 &&
          citaSeleccionada.idCatTipoCita == 11 &&
          !citaSeleccionada.paciente &&
          !datosPaciente.nombrePaciente
        ) {
          fail("Por favor, introduzca el nombre del paciente para la cita de primera vez");
          return;
        }
        if (
          !errorCita &&
          citaSeleccionada.tipoEspacio == 1 &&
          citaSeleccionada.idCatTipoCita == 11 &&
          !citaSeleccionada.paciente &&
          !datosPaciente.telefonoPaciente
        ) {
          fail("Por favor, introduzca el teléfono del paciente para la cita de primera vez");
          return;
        }
      
        if (!errorCita && !citaSeleccionada.comentarioRecepcion) {
          fail("Por favor, introduzca los comentarios para la cita");
          return;
        }
      
        // ===== Preparaciones auxiliares =====
        let comentario = null;
        if (
          citaSeleccionada.idCatTipoCita == 11 &&
          citaSeleccionada.tipoEspacio == 1 &&
          (citaSeleccionada.paciente == null || citaSeleccionada.paciente == "") &&
          !UISweetAlert.editar
        ) {
          comentario =
            `${citaSeleccionada.comentarioRecepcion}\n` +
            `Nombre del Paciente: ${datosPaciente.nombrePaciente}\n` +
            `Telefono del paciente: ${datosPaciente.telefonoPaciente}`;
        }
      
        // Título
        let titulo = null;
        if (citaSeleccionada.tipoEspacio == 1) {
          const tipoSel = tipoCitas.find(t => t.idCatTipoCita == citaSeleccionada.idCatTipoCita);
          titulo = tipoSel ? tipoSel.tipoCita : citaSeleccionada.title;
        }
        if (citaSeleccionada.tipoEspacio == 3) {
          titulo = tituloFormatear();
        }
        const tituloModificado =
          (citaSeleccionada.tipoEspacio == 1 || citaSeleccionada.tipoEspacio == 3) && titulo
            ? titulo
            : citaSeleccionada.title;
      
        // (Opcional) solicitud expediente — se prepara solo si aplica
        setLoading(true);
      
        // ====== Construcción de LOG y detección de cambios locales ======
        let banderaEncontrado = false;
        let cadenaGeneral     = "";
        const banderaNuevo    = !citaSeleccionada.id;



      
        if (!banderaNuevo) {
          cadenaGeneral = `Actualización:ID[${citaSeleccionada.id}]`;
      
          // Normalizaciones para evitar cambios fantasma null vs ""
          const crSel = citaSeleccionada.comentarioRecepcion   ?? "";
          const crOri = comentarioRecepcionOriginal            ?? "";
          if (crSel !== crOri) {
            cadenaGeneral += `,CR[${crOri}->${crSel}]`;
            banderaEncontrado = true;
          }
      
          const caSel = citaSeleccionada.comentarioAseguradora ?? "";
          const caOri = comentarioAseguradoraOriginal          ?? "";
          if (caSel !== caOri) {
            cadenaGeneral += caOri ? `,CA[${caOri}->${caSel}]` : `,CA[->${caSel}]`;
            banderaEncontrado = true;
          }
      
          const cfSel = citaSeleccionada.comentarioFarmacia ?? "";
          const cfOri = comentarioFarmaciaOriginal          ?? "";
          if (cfSel !== cfOri) {
            cadenaGeneral += cfOri ? `,CF[${cfOri}->${cfSel}]` : `,CF[->${cfSel}]`;
            banderaEncontrado = true;
          }
      
          const ctSel = citaSeleccionada.comentarioTratamiento ?? "";
          const ctOri = comentarioTratamientoOriginal          ?? "";
          if (ctSel !== ctOri) {
            cadenaGeneral += ctOri ? `,CT[${ctOri}->${ctSel}]` : `,CT[->${ctSel}]`;
            banderaEncontrado = true;
          }
      
          // Cambio de paciente (por nombre visible)
          if ((citaSeleccionada.nombrePaciente ?? "") !== (paciente ?? "")) {
            cadenaGeneral += `,P[${paciente ?? "SIN ASIGNAR"}->${citaSeleccionada.nombrePaciente ?? "SIN ASIGNAR"}]`;
            banderaEncontrado = true;
          }
      
          // Cambio de paciente (por ID)
          if (citaSeleccionada.paciente != pacienteIdOriginal) {
            let originalNombre = "SIN ASIGNAR";
            let nuevoNombre    = "SIN ASIGNAR";
            pacientes?.forEach(p => {
              if (p.idCatPaciente == pacienteIdOriginal)
                originalNombre = `${p.nombres} ${p.apellidoPaterno} ${p.apellidoMaterno}`;
              if (p.idCatPaciente == citaSeleccionada.paciente)
                nuevoNombre = `${p.nombres} ${p.apellidoPaterno} ${p.apellidoMaterno}`;
            });
            cadenaGeneral += `,P[${originalNombre}->${nuevoNombre}]`;
            banderaEncontrado = true;
          }
      
          // Cambio de consultorio
          if ((citaSeleccionada.consultorio ?? "") !== (consultorio ?? "")) {
            cadenaGeneral += `,C[${consultorio ?? "SIN ASIGNAR"}->${citaSeleccionada.consultorio ?? "SIN ASIGNAR"}]`;
            banderaEncontrado = true;
          }
      
          // Fechas
          const citaTodoDia = !!citaSeleccionada.todoDia;
          if (!areDatesEquivalent(citaSeleccionada.start, fechaInicio, citaTodoDia)) {
            cadenaGeneral += `,FI[${fechaInicio}->${citaSeleccionada.start}]`;
            banderaEncontrado = true;
          }
          if (!areDatesEquivalent(citaSeleccionada.end, fechafinal, citaTodoDia)) {
            cadenaGeneral += `,FF[${fechafinal}->${citaSeleccionada.end}]`;
            banderaEncontrado = true;
          }
        } else {
          // NUEVA CITA
          if (citaSeleccionada.end) {
            cadenaGeneral = `Nuevo:ID[@@],FI[${citaSeleccionada.start}],FF[${citaSeleccionada.end}]`;
          } else {
            cadenaGeneral = `Nuevo:ID[@@],TD[${citaSeleccionada.start}]`;
          }
          const nombrePac = nombrePacienteGlobal || TraePaciente(citaSeleccionada.paciente);
          cadenaGeneral += `,P[${nombrePac}],CR[${citaSeleccionada.comentarioRecepcion}]`;
        }
      
        // Cambio de espacio/médico (por idEspacio)
        const espNuevo = espaciosAtencionAgenda?.find(e => e.idEspacio == citaSeleccionada.espacio);
        const espOri   = espaciosAtencionAgenda?.find(e => e.idEspacio == espacioOriginal);
        if ((espNuevo?.espacio ?? "") !== (espOri?.espacio ?? "")) {
          cadenaGeneral += !banderaNuevo
            ? `,E[${espOri?.espacio ?? "SIN ASIGNAR"}->${espNuevo?.espacio ?? "SIN ASIGNAR"}]`
            : `,E[${espNuevo?.espacio ?? "SIN ASIGNAR"}]`;
          banderaEncontrado = true;
        }
      
        // Cambio de tipo de cita
        const tipoNuevo = tipoCitas?.find(t => t.idCatTipoCita == citaSeleccionada.idCatTipoCita);
        const tipoOri   = tipoCitas?.find(t => t.idCatTipoCita == tipoCitaId);
        if ((tipoNuevo?.tipoCita ?? "") !== (tipoOri?.tipoCita ?? "")) {
          cadenaGeneral += !banderaNuevo
            ? `,TC[${tipoOri?.tipoCita ?? "SIN ASIGNAR"}->${tipoNuevo?.tipoCita ?? "SIN ASIGNAR"}]`
            : `,TC[${tipoNuevo?.tipoCita ?? "SIN ASIGNAR"}]`;
          banderaEncontrado = true;
        }
      
        // Si NO hay cambios y NO es nueva → no guardes “fantasmas”
        if (!banderaEncontrado && !banderaNuevo) {
          setLoading(false);
          setAutoPause(false);
          setUISweetAlert({
            ...sweetAlertDefault,
            success_dlg: true,
            dynamic_title: "Sin cambios",
            dynamic_description: "No hay cambios por guardar.",
          });          
          liberarGuardadoCita();
          return;
        }
      
        // ====== Verificación contra backend SOLO si: cita existente + hubo cambios locales ======
        if (!banderaNuevo && banderaEncontrado && !ignorarBack && !confirmaSobreEscribirCita) {
          const citaBack = await traerCita(citaSeleccionada.id).catch(() => null);
          const cadenaCambioDetectado = citaBack ? CitaModificada(citaBack) : "";
          setMensajeSobreEscribirCita(cadenaCambioDetectado);
          if (cadenaCambioDetectado && cadenaCambioDetectado.length > 1) {
            setLoading(false);
            setConfirmaSobreEscribirCita(true);
            setAutoPause(false);
            liberarGuardadoCita();
            return;
          }
        }
      
        // ====== Guardado ======
        try {
          const res = await uploadCita({
            id: banderaNuevo ? null : citaSeleccionada.id,
            updatedAt: banderaNuevo ? null : (citaSeleccionada.updatedAt ?? null),
            title: tituloModificado,
            start: citaSeleccionada.start,
            end: citaSeleccionada.end,
            className: citaSeleccionada.className ? citaSeleccionada.className : null,
            logVo: !banderaEncontrado
              ? null
              : {
                  idUsuario: usuario.idUsuario,
                  modulo: "Agenda",
                  actividad: cadenaGeneral,
                },
            extendedProps: {
              espacio: citaSeleccionada.espacio,
              tipoEspacio: citaSeleccionada.tipoEspacio,
              comentarioRecepcion:
                comentario && citaSeleccionada.idCatTipoCita == 11 && !UISweetAlert.editar
                  ? comentario
                  : (citaSeleccionada.comentarioRecepcion ?? ""),
              paciente: citaSeleccionada.paciente,
              nombrePaciente: nombrePacienteGlobal,
              comentarioAseguradora: (citaSeleccionada.comentarioAseguradora ?? ""),
              comentarioFarmacia:    (citaSeleccionada.comentarioFarmacia ?? ""),
              comentarioTratamiento: (citaSeleccionada.comentarioTratamiento ?? ""),
              salvaComentarioTratamiento: (comentarioTratamientoOriginal ?? "") !== (citaSeleccionada.comentarioTratamiento ?? ""),
              salvaComentarioRecepcion:   (comentarioRecepcionOriginal   ?? "") !== (citaSeleccionada.comentarioRecepcion   ?? ""),
              salvaComentarioFarmacia:    (comentarioFarmaciaOriginal    ?? "") !== (citaSeleccionada.comentarioFarmacia    ?? ""),
              salvaComentarioAseguradora: (comentarioAseguradoraOriginal ?? "") !== (citaSeleccionada.comentarioAseguradora ?? ""),
              todoDia: citaSeleccionada.todoDia,
              idCatTipoCita: citaSeleccionada.idCatTipoCita,
              consultorio: citaSeleccionada.consultorio,
              solicitaMedico: esAsistente ? true : (usuario.idCatMedico != null ? true : false),
              usuarioSolicitante: usuario.nombre,
              idCatMedico: citaSeleccionada.idCatMedico,
            },
          });
       
          if (res.data.error) {
            const errorConexion = res.data.errorConexion === true;
            setLoading(false);
            if (!errorConexion) {
              LimpiarDatos();
            }
            setAutoPause(errorConexion);
            setUISweetAlert({
              ...sweetAlertDefault,
              confirm_alert_cita: errorConexion,
              editar: errorConexion ? UISweetAlert.editar : false,
              error_dlg: true,
              dynamic_title: "Fallo",
              dynamic_description: res.data.message,
            });
          } else {
            // ⬇️ Mantengo tu flujo original posterior al guardado
            const newStartDate = new Date();
            const startDateStr = formatDate(newStartDate, true);
            const newEndDate   = new Date(new Date().getTime() + tiempoCita);
            const endDateStr   = formatDate(newEndDate, true);
            setCitaSeleccionada({ start: startDateStr, end: endDateStr });
            setDisabledEditar(false);
            setDatosPaciente({});
      
            const espacios = esAsistente
              ? espaciosAtencionDefault
              : (usuario.idCatMedico ? espaciosAtencionDefault : opcionesEspacios);
      
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              opcionesExtras.seleccionarTodosEspacios = false;
            }
      
            // Nota: si más adelante prefieres NO recargar todo, se puede omitir listarCitas.
              // === 3B: actualizar siempre los filtros/rango vigentes para el timer ===
            const { viewStart, viewEnd } = (typeof getViewRange === "function" && getViewRange()) || {
            viewStart: filtrosRef.current.viewStart,
            viewEnd:   filtrosRef.current.viewEnd,
            };
            
            filtrosRef.current = {
            viewStart,
            viewEnd,
            espaciosVo: espacios || [],
            // Usa los mismos arrays que mandas a listarCitas en esta función
            pacientesVo: opcionesPacientes || [],
            aseguradorasVo: opcionesAseguradoras || [],
            todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
            todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
            porAseguradora: !!opcionesExtras.porAseguradora,
            incluirTratamientos: false,
            incluirCitas: false,
            };

            listarCitas(
              fechaActual,
              espacios,
              opcionesPacientes,
              opcionesAseguradoras,
              opcionesExtras.seleccionarTodosEspacios,
              opcionesExtras.seleccionarTodosPacientes,
              opcionesExtras.porAseguradora
            );
      
            if (esMedico || esAsistente) {
              opcionesExtras.seleccionarTodosEspacios = temporal;
            }
      
            LimpiarDatos();
            setLoading(false);
            setAutoPause(false);
            if (res.data.consultorio != null && citaSeleccionada.tipoEspacio == 1) {
              setUISweetAlert({
                ...sweetAlertDefault,
                success_dlg: true,
                dynamic_title: "Éxito",
                dynamic_description: `Se guardaron los cambios de la cita, consultorio: ${res.data.consultorio}`,
              });
            } else {
              setUISweetAlert({
                ...sweetAlertDefault,
                success_dlg: true,
                dynamic_title: "Éxito",
                dynamic_description: "Se guardaron los cambios de la cita",
              });
            }
          }
        } catch (error) {
          setLoading(false);
          setAutoPause(true);
          setUISweetAlert({
            ...sweetAlertDefault,
            confirm_alert_cita: true,
            editar: UISweetAlert.editar,
            error_dlg: true,
            dynamic_title: "Fallo",
            dynamic_description: "Error en el servidor",
          });
        }

        liberarGuardadoCita();
    };
            
    const tituloFormatear = () => {
        let nombrePaciente = "";
        let nombreMedico = "";
        let nombreTipoCita = "";

        if (citaSeleccionada.paciente != null) {
            const pacienteFiltrado = pacientes.filter((paciente) => {
                if (paciente.idCatPaciente == citaSeleccionada.paciente) return paciente;
            });
            if (pacienteFiltrado && pacienteFiltrado.length > 0) {
                nombrePaciente =
                    (pacienteFiltrado[0].nombres ? pacienteFiltrado[0].nombres : "") +
                    " " +
                    (pacienteFiltrado[0].apellidoPaterno ? pacienteFiltrado[0].apellidoPaterno : "") +
                    " " +
                    (pacienteFiltrado[0].apellidoMaterno ? pacienteFiltrado[0].apellidoMaterno : "");
            }
        }

        if (citaSeleccionada.idCatMedico != null) {
            const medicoFiltrado = medicos.filter((medico) => {
                if (medico.idCatMedico == citaSeleccionada.idCatMedico) return medico;
            });

            if (medicoFiltrado && medicoFiltrado.length > 0 && medicoFiltrado[0].catPersona) {
                nombreMedico =
                    (medicoFiltrado[0].catPersona.nombres ? medicoFiltrado[0].catPersona.nombres : "") +
                    " " +
                    (medicoFiltrado[0].catPersona.apellidoPaterno ? medicoFiltrado[0].catPersona.apellidoPaterno : "") +
                    " " +
                    (medicoFiltrado[0].catPersona.apellidoMaterno ? medicoFiltrado[0].catPersona.apellidoMaterno : "");
            }
        }

        if (citaSeleccionada.idCatTipoCita != null) {
            const tipoCitaFiltrada = tipoCitas.filter((tipoCita) => {
                if (tipoCita.idCatTipoCita == citaSeleccionada.idCatTipoCita) return tipoCita;
            });

            if (tipoCitaFiltrada && tipoCitaFiltrada.length > 0) {
                nombreTipoCita = tipoCitaFiltrada[0].tipoCita ? tipoCitaFiltrada[0].tipoCita : "";
            }
        }

        return nombrePaciente + " - " + nombreMedico + " - " + nombreTipoCita;
    };

    const cambioHoraCita = async (e) => {
        if (autorizado) {
            if (new Date() > e.oldEvent.start) {
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Citas que su hora de inicio ya paso, no pueden ser modificadas.",
                });
                return;
            }

            if (new Date() > e.event.start) {
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "No se pueden mover a citas al pasado.",
                });
                return;
            }

            setLoading(true);
            try {
                let diffMinutes = 0; // 
                let fechaback = null;
                if(e.event.endStr==''){
                    citas.map((cita) =>
                    {
                        if(cita.id == e.event.id){
                            const fechaIni = new Date(cita.start);
                            const fechaFin = new Date(cita.end);
                            const diffTime = Math.abs(fechaFin - fechaIni);
                            diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60)); // 
                            
                            const newDateObj = new Date(e.event.startStr);
                            newDateObj.setMinutes(newDateObj.getMinutes() + diffMinutes);
                            fechaback = new Date(newDateObj);
                        }
                    })                     
                }

                const res = await uploadCita({
                    id: e.event.id,
                    start: e.event.startStr,
                    end: e.event.endStr != ''? e.event.endStr : fechaback,
                    title: e.event.title,
                    extendedProps: e.event.extendedProps,
                    className: e.event.classNames[0],
                });

                if (res.data.error) {
                    setLoading(false);

                    setUISweetAlert({
                        ...sweetAlertDefault,
                        error_dlg: true,
                        dynamic_title: "Fallo",
                        dynamic_description: res.data.message,
                    });
                } else {
                    setLoading(false);
                    
                    setUISweetAlert({
                        ...sweetAlertDefault,
                        success_dlg: true,
                        dynamic_title: "Éxito",
                        dynamic_description: "Se guardaron los cambios de la cita" ,
                    });
                }
            } catch (error) {
                setLoading(false);
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Ocurrió un error, por favor intentalo más tarde.",
                });
            }
        } else {
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "No tienes los permisos necesarios para cambiar la fecha de una cita.",
            });
        }
    };

    const viewchange = async (e) => {
        if (e.view.type == "dayGridMonth") {
            setMostrarFinDeSemana(true);
        } else {
            setMostrarFinDeSemana(true);
        }
    };

    const changeEspacioFiltro = async (optionsPar) => {
        setAutoPause(true);
        setLoading(true);
        if(optionsPar.length > 0){
            setExistenFiltros(true);
        }else{
            setExistenFiltros(false);
        }
        //setOpcionesEspacios(optionsPar);
        setFiltroCitasEspacios(optionsPar);

        setOpcionesEspacios( 
            optionsPar.map((optionsInt) =>
            {
                    return optionsInt; 
            })  
        )

        try {

            const { viewStart, viewEnd } =
            (typeof getViewRange === "function" && getViewRange()) || {
              viewStart: filtrosRef.current.viewStart,
              viewEnd:   filtrosRef.current.viewEnd,
            };
      
            filtrosRef.current = {
                viewStart,
                viewEnd,
                espaciosVo: optionsPar || [],
                pacientesVo: opcionesPacientes || [],
                aseguradorasVo: opcionesAseguradoras || [],
                todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
                todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
                porAseguradora: !!opcionesExtras.porAseguradora,
                incluirTratamientos: false,
                incluirCitas: false,
            };
            
            let temporal = false;
            if(esMedico || esAsistente){
                temporal = opcionesExtras.seleccionarTodosEspacios;
                opcionesExtras.seleccionarTodosEspacios =  false;
            }

            const res = await listarCitas(
                fechaActual,
                optionsPar, 
                opcionesPacientes,
                opcionesAseguradoras,
                opcionesExtras.seleccionarTodosEspacios,
                opcionesExtras.seleccionarTodosPacientes,
                opcionesExtras.porAseguradora
            );
            
            if(esMedico || esAsistente){
                opcionesExtras.seleccionarTodosEspacios =  temporal;
            }

            await delay(delayTime);
            setLoading(false);
            setAutoPause(false);
            return res;
        } catch (error) {
            setLoading(false);
            setAutoPause(false);
            //console.log(error);
        }
    };

    const changeAseguradoraFiltro = async (optionsPar) => {
        setAutoPause(true);
        setLoading(true);
      
        if (optionsPar && optionsPar.length > 0) {
          setExistenFiltros(true);
        } else {
          setExistenFiltros(false);
        }
      
        setFiltroCitasAseguradoras(optionsPar);
        setOpcionesAseguradoras(optionsPar?.map(o => o) || []);
      
        try {
          // === 3B: sincroniza rango/filtros para el timer ===
          const { viewStart, viewEnd } =
            (typeof getViewRange === "function" && getViewRange()) || {
              viewStart: filtrosRef.current.viewStart,
              viewEnd:   filtrosRef.current.viewEnd,
            };
      
          filtrosRef.current = {
            viewStart,
            viewEnd,
            espaciosVo: opcionesEspacios || [],
            pacientesVo: opcionesPacientes || [],
            aseguradorasVo: optionsPar || [],
            todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
            todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
            porAseguradora: !!opcionesExtras.porAseguradora,
            incluirTratamientos: false,
            incluirCitas: false,
          };
          // =================================================
      
          const res = await listarCitas(
            fechaActual,
            opcionesEspacios,
            opcionesPacientes,
            optionsPar,
            opcionesExtras.seleccionarTodosEspacios,
            opcionesExtras.seleccionarTodosPacientes,
            opcionesExtras.porAseguradora
          );
      
          await delay(delayTime);
          setLoading(false);
          setAutoPause(false);
          return res;
        } catch (error) {
          setLoading(false);
          setAutoPause(false);
        }
    };
      

    const changePacientesFiltro = async (optionsPar) => {
        setAutoPause(true);
        setLoading(true);
      
        setOpcionesPacientes(optionsPar);
        setFiltroCitasPacientes(optionsPar);
      
        const espacios = esAsistente
          ? espaciosAtencionDefault
          : (usuario.idCatMedico ? espaciosAtencionDefault : filtroCitasEspacios);
      
        try {
          let temporal = false;
          if (esMedico || esAsistente) {
            temporal = opcionesExtras.seleccionarTodosEspacios;
            opcionesExtras.seleccionarTodosEspacios = false;
          }
      
          if (optionsPar) {
            opcionesExtras.seleccionarTodosPacientes = false;
          }
      
          // === 3B: sincroniza rango/filtros para el timer ===
          const { viewStart, viewEnd } =
            (typeof getViewRange === "function" && getViewRange()) || {
              viewStart: filtrosRef.current.viewStart,
              viewEnd:   filtrosRef.current.viewEnd,
            };
      
          filtrosRef.current = {
            viewStart,
            viewEnd,
            espaciosVo: espacios || [],
            pacientesVo: optionsPar || [],
            aseguradorasVo: opcionesAseguradoras || [],
            todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
            todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
            porAseguradora: !!opcionesExtras.porAseguradora,
            incluirTratamientos: false,
            incluirCitas: false,
          };
          // ==================================================
      
          const res = await listarCitas(
            fechaActual,
            espacios,
            optionsPar,
            opcionesAseguradoras,
            opcionesExtras.seleccionarTodosEspacios,
            opcionesExtras.seleccionarTodosPacientes,
            opcionesExtras.porAseguradora
          );
      
          if (esMedico || esAsistente) {
            opcionesExtras.seleccionarTodosEspacios = temporal;
          }
      
          await delay(delayTime);
          setLoading(false);
          setAutoPause(false);
          return res;
        } catch (error) {
          setLoading(false);
          setAutoPause(false);
        }
    };
      

    const checkIncluyeEspacioMedico = () => {
        let hayEspacioMedico = false;
        if (opcionesExtras.seleccionarTodosEspacios) {
            return true;
        } else if (filtroCitasEspacios && filtroCitasEspacios.length > 0) {
            const numeroDeEspacios = filtroCitasEspacios.length;
            for (let i = 0; i < numeroDeEspacios; i++) {
                if (filtroCitasEspacios[i].idCatTipoEspacio == 1) {
                    hayEspacioMedico = true;
                    break;
                }
            }
            return hayEspacioMedico;
        } else {
            return false;
        }
    };

    const RefreshCalendar = async () => {
        setAutoPause(true);
        let startDate = infoCalGlobal;
      
        const fechaFormateada = formatDate(startDate, true, true);
      
        setFechaActual(fechaFormateada);
        setFiltrosImpresion({ fechaImpresion: fechaFormateada, incluirCitas: true, incluirTratamientos: true });
      
        const espacios = esAsistente
          ? espaciosAtencionDefault
          : (usuario.idCatMedico ? espaciosAtencionDefault : filtroCitasEspacios);
      
        // === 3B: sincroniza rango/filtros para el timer ===
        const { viewStart, viewEnd } =
          (typeof getViewRange === "function" && getViewRange()) || {
            viewStart: filtrosRef.current.viewStart,
            viewEnd:   filtrosRef.current.viewEnd,
          };
      
        filtrosRef.current = {
          viewStart,
          viewEnd,
          espaciosVo: espacios || [],
          pacientesVo: filtroCitasPacientes || [],
          aseguradorasVo: opcionesAseguradoras || [],
          todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
          todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
          porAseguradora: !!opcionesExtras.porAseguradora,
          incluirTratamientos: false,
          incluirCitas: false,
        };
        // ==================================================
      
        setLoading(true);
        try {
          let temporal = false;
          if (esMedico || esAsistente) {
            temporal = opcionesExtras.seleccionarTodosEspacios;
            opcionesExtras.seleccionarTodosEspacios = false;
          }
      
          const res = await listarCitas(
            fechaFormateada,
            espacios,
            filtroCitasPacientes,
            opcionesAseguradoras,
            opcionesExtras.seleccionarTodosEspacios,
            opcionesExtras.seleccionarTodosPacientes,
            opcionesExtras.porAseguradora
          );
      
          if (esMedico || esAsistente) {
            opcionesExtras.seleccionarTodosEspacios = temporal;
          }
          await delay(delayTime);
          setLoading(false);
          setAutoPause(false);
          return res;
        } catch (error) {
          setLoading(false);
          setAutoPause(false);
        }
    };
      

    // AUTOREFRESH

    const updatedSinceRef = useRef(null);
    
    const getViewRange = () => {
      const api = calendarComponentRef?.current?.getApi?.();
      if (!api) return { viewStart: null, viewEnd: null };
      const { activeStart: viewStart, activeEnd: viewEnd } = api.view;
      return { viewStart, viewEnd };
    };
    
    const RefreshCalendarChanges = async ({ silent = false } = {}) => {
        try {
          const { viewStart, viewEnd } = getViewRange();
          if (!viewStart || !viewEnd) return;
      
          // mismas reglas que ya usas para espacios/filtros:
          const espacios = esAsistente
            ? espaciosAtencionDefault
            : (usuario?.idCatMedico ? espaciosAtencionDefault : filtroCitasEspacios);
      
          if (!silent) {
            setLoading(true);
          }
      
          let backup = false;
          if (esMedico || esAsistente) {
            backup = opcionesExtras.seleccionarTodosEspacios;
            opcionesExtras.seleccionarTodosEspacios = false;
          }
      
          await fetchAndApplyCitasChanges(
            {
              viewStart,
              viewEnd,
              limit: 300,
              espacios,
              pacientes: filtroCitasPacientes,
              aseguradoras: opcionesAseguradoras,
              todosEspacios: opcionesExtras.seleccionarTodosEspacios,
              todosPacientes: opcionesExtras.seleccionarTodosPacientes,
              porAseguradora: opcionesExtras.porAseguradora,
            },
            {
              idsEnEdicion: new Set(),   // pasa tus ids en edición si los tienes en un ref
            }
          );
      
          // Nota: el cursor (updatedSinceRef.current) ya fue avanzado por fetchAndApplyCitasChanges.
          // Si quieres mantenerlo visible para depuración, puedes dejar la línea siguiente opcional:
          // if (maxUpdatedAtISO) updatedSinceRef.current = maxUpdatedAtISO;
      
          if (esMedico || esAsistente) {
            opcionesExtras.seleccionarTodosEspacios = backup;
          }
        } finally {
          if (!silent) {
            await delay?.(delayTime);
            setLoading(false);
          }
        }
    };
      

    // Change fecha causa llamado a listarCitas cuando el componente se renderiza
    const changeFecha = async (info) => {
        let startDate = info.start;
        setInfoCalGlobal(startDate);
      
        const fechaFormateada = formatDate(startDate, true, true);
      
        setFechaActual(fechaFormateada);
        setFiltrosImpresion({ fechaImpresion: fechaFormateada, incluirCitas: true, incluirTratamientos: true });
      
        const espacios = esAsistente
          ? espaciosAtencionDefault
          : (usuario.idCatMedico ? espaciosAtencionDefault : filtroCitasEspacios);
      
        // === 3B: actualizar siempre los filtros/rango vigentes para el timer ===
        filtrosRef.current = {
          viewStart: info.start,
          viewEnd: info.end,
          espaciosVo: espacios || [],
          pacientesVo: filtroCitasPacientes || [],
          aseguradorasVo: opcionesAseguradoras || [],
          todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
          todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
          porAseguradora: !!opcionesExtras.porAseguradora,
          incluirTratamientos: false,
          incluirCitas: false,
        };
        // ======================================================================
      
        if (espacios != null) {
          if (espacios.length > 0) {
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              opcionesExtras.seleccionarTodosEspacios = false;
            }
      
            setLoading(true);
            setAutoPause(true);
            try {
              const res = await listarCitas(
                fechaFormateada,
                espacios,
                filtroCitasPacientes,
                opcionesAseguradoras,
                opcionesExtras.seleccionarTodosEspacios,
                opcionesExtras.seleccionarTodosPacientes,
                opcionesExtras.porAseguradora
              );
      
              if (esMedico || esAsistente) {
                opcionesExtras.seleccionarTodosEspacios = temporal;
              }
      
              await delay(delayTime);
              setLoading(false);
              setAutoPause(false);
              return res;
            } catch (error) {
              setLoading(false);
              setAutoPause(false);
            }
          }
        } else {
          setAutoPause(true);
          setLoading(true);
          try {
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              opcionesExtras.seleccionarTodosEspacios = false;
            }
      
            const res = await listarCitas(
              fechaFormateada,
              espacios,
              filtroCitasPacientes,
              opcionesAseguradoras,
              opcionesExtras.seleccionarTodosEspacios,
              opcionesExtras.seleccionarTodosPacientes,
              opcionesExtras.porAseguradora
            );
      
            if (esMedico || esAsistente) {
              opcionesExtras.seleccionarTodosEspacios = temporal;
            }
      
            await delay(delayTime);
            setLoading(false);
            setAutoPause(false);
            return res;
          } catch (error) {
            setLoading(false);
            setAutoPause(false);
          }
        }
      };
      

    const nuevoPacienteRedirect = async () => {
        if (banCrearPaciente) {
            setIdCatPacienteSeleccionado(null);
            props.history.push("/historia/clinica/inicial");
        } else {
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "No tiene habilitada la creación de un nuevo paciente desde este módulo.",
            });
        }
    };

    const changePacienteNuevaCita = async (option) => {
        const idCatPaciente = option?.idCatPaciente;

        if (idCatPaciente == null || idCatPaciente === "") {
            setComentarioPaciente("");
            setPacienteDeCitaSeleccionada(null);
            setCitaSeleccionada((prev) => ({
                ...prev,
                paciente: "",
            }));
            return;
        }

        let comentariosPacienteLocal = TraeComentariosPaciente(idCatPaciente);
        if (comentariosPacienteLocal == null) {
            comentariosPacienteLocal = option.comentario ?? "Sin comentarios";
        }
        setComentarioPaciente(comentariosPacienteLocal);

        const pacienteCompletoCita = filterPacienteCitaSeleccionada(idCatPaciente);
        if (!pacienteCompletoCita) {
            setPacienteDeCitaSeleccionada(option);
        }

        setCitaSeleccionada((prev) => ({
            ...prev,
            paciente: idCatPaciente,
        }));
    };

    const changePacienteHistorico = async (option) => {
        if (option == null) {
            setPacienteSeleccionadoHistorico("");
        } else {
            setAutoPause(true);
            setLoading(true);
            setPacienteSeleccionadoHistorico(option);
            try {
                const res = await listarCitasPaciente(option.idCatPaciente);

                if (res && res.data) {
                    setLoading(false);
                    setCitasPaciente(res.data);
                } else {
                    setLoading(false);
                    setUISweetAlert({
                        ...sweetAlertDefault,
                        error_dlg: true,
                        dynamic_title: "Fallo",
                        dynamic_description: "Error en el servidor.",
                    });
                }
                setLoading(false);
                setAutoPause(false);
            } catch (error) {
                setLoading(false);
                setAutoPause(false);
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Error en el servidor.",
                });
            }
        }
    };

    const expedienteMedicoPaciente = async () => {
        setIdCatPacienteSeleccionado(citaSeleccionada.paciente);
        window.open("/historia/clinica/inicial");
    };

    useEffect(() => {
        setFiltroCitasEspacios(null);

        setOpcionesExtras({
            ...opcionesExtras,
            seleccionarTodosEspacios : true,
            porAseguradora : false,
            seleccionarTodosPacientes : true,
        });
        const filterEspaciosMedico = checkIfMedico();

        filterEspaciosMedico();
        checkHorarioEspacio();
      
    }, []);

    // AUTO REFRESH,  ACA SE CREA EL TIMER QUE CONTROLA EL REFRESQUEO
    useEffect(() => {
        let id;
      
        const tick = async () => {
          if (pausaRef.current) return;      // pausado (modal/edición)
          if (document.hidden) return;       // pestaña oculta
          if (refreshInFlightRef.current) return;
      
          refreshInFlightRef.current = true;
          try {
            if (refreshFnRef.current) {
                //await refreshFnRef.current();
                await refreshFnRef.current({ silent: true });
              }
          } finally {
            refreshInFlightRef.current = false;
          }
        };
      
        id = setInterval(tick, REFRESH_INTERVAL_MS);
      
        const onVis = () => { if (!document.hidden) tick(); };
        document.addEventListener('visibilitychange', onVis);
      
        return () => {
          clearInterval(id);
          document.removeEventListener('visibilitychange', onVis);
        };
        // deps vacías: el intervalo no se recrea
    }, []);

    useEffect(() => {
        refreshFnRef.current = RefreshCalendarChanges;
    }, [RefreshCalendarChanges]);
        
    // Pausa/reaunuda el auto-refresh y bloquea/desbloquea ejecuciones en vuelo
    const setAutoPause = (on) => {
        const val = !!on;
        pausaRef.current = val;          // lo que lee el timer
        setPausa(val);                   // estado para UI (si lo usas)
        refreshInFlightRef.current = val; // evita que entre/siga un tick durante la pausa
    };    

    const imprimirAgenda = () => {
        if (banImprimiragenda) {
            setAutoPause(true);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_imprimir_agenda: true,
            });
        }else{
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Aviso!",
                dynamic_description: "No tienes los permisos para imprimir la agenda",
            });
        }
    };

    const visualizarDiaCitas = () => {
        if (banImprimiragenda) {
            setAutoPause(true);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_exponer_agenda: true,
            });
        }
    };

    const visualizarDiaCitasGeneral = () => {
        if (banImprimiragenda) {
            setAutoPause(true);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_exponer_agendaGeneral: true,
            });
        }
    };

    const visualizarCitas = async () => {
        if (checkIncluyeEspacioMedico()) {
            if (!filtrosImpresion.incluirTratamientos && !filtrosImpresion.incluirCitas) {
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Se requiere tener al menos seleccionado el checkbox incluir tratamientos o incluir citas",
                });
                return;
            }
        }
        try {
            const datos = {
                fechaBusqueda: filtrosImpresion.fechaImpresion,
                todosEspacios: opcionesExtras.seleccionarTodosEspacios ? opcionesExtras.seleccionarTodosEspacios : false,
                todosPacientes: opcionesExtras.seleccionarTodosPacientes ? opcionesExtras.seleccionarTodosPacientes : false,
                porDia: filtrosImpresion.porDia,
                incluirTratamientos: filtrosImpresion.incluirTratamientos,
                incluirCitas: filtrosImpresion.incluirCitas,
                porAseguradora: opcionesExtras.porAseguradora ? opcionesExtras.porAseguradora : false,
                espaciosVo: opcionesExtras.seleccionarTodosEspacios ? null : filtroCitasEspacios,
            }
            openNewWindow(datos);

        } catch (error) {
            setLoading(false);
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "Error en el servidor",
            });
        }

        // exportAgenda({ ...filtrosImpresion, espacios: espaciosImpresion });
    };

    const visualizarCitasGeneral = async () => {
        if (checkIncluyeEspacioMedico()) {
            if (!filtrosImpresion.incluirTratamientos && !filtrosImpresion.incluirCitas) {
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Se requiere tener al menos seleccionado el checkbox incluir tratamientos o incluir citas",
                });
                return;
            }
        }
        try {
            const datos = {
                fechaBusqueda: filtrosImpresion.fechaImpresion,
                todosEspacios: opcionesExtras.seleccionarTodosEspacios ? opcionesExtras.seleccionarTodosEspacios : false,
                todosPacientes: opcionesExtras.seleccionarTodosPacientes ? opcionesExtras.seleccionarTodosPacientes : false,
                porDia: filtrosImpresion.porDia,
                incluirTratamientos: filtrosImpresion.incluirTratamientos,
                incluirCitas: filtrosImpresion.incluirCitas,
                porAseguradora: opcionesExtras.porAseguradora ? opcionesExtras.porAseguradora : false,
                espaciosVo: opcionesExtras.seleccionarTodosEspacios ? null : filtroCitasEspacios,
            }
            openNewWindowGeneral(datos);
        } catch (error) {
            setLoading(false);
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "Error en el servidor",
            });
        }

        // exportAgenda({ ...filtrosImpresion, espacios: espaciosImpresion });
    };
    

    const confirmImprimirAgenda = async () => {
        const conFiltros =
            ((filtroCitasEspacios && filtroCitasEspacios.length >= 1) ||
                (espaciosAtencionDefault && espaciosAtencionDefault.length >= 1) ||
                (filtroCitasPacientes && filtroCitasPacientes.length >= 1) ||
                opcionesExtras.seleccionarTodosEspacios ||
                opcionesExtras.seleccionarTodosPacientes) &&
            filtrosImpresion.fechaImpresion &&
            filtrosImpresion.fechaImpresion !== "";

        if (checkIncluyeEspacioMedico()) {
            if (!filtrosImpresion.incluirTratamientos && !filtrosImpresion.incluirCitas) {
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Se requiere tener al menos seleccionado el checkbox incluir tratamientos o incluir citas",
                });
                return;
            }
        }
        if ((!filtrosImpresion.porDia && conFiltros) ) {
            // TODO: Se debe agregar también en exportAgendaB los filtros de pacientes y el filtro si estan seleccionado todo
            setLoading(true);

            if(esAsistente || esMedico){
                opcionesExtras.seleccionarTodosEspacios =  false;
            }

            if (filtroCitasEspacios && filtroCitasEspacios.length > 0 && !opcionesExtras.seleccionarTodosEspacios) {
                filtroCitasEspacios.forEach(async (espacio) => {
                    // eslint-disable-next-line
                    
                    try {
                        const res = await exportAgenda({...filtrosImpresion, espacioVo: espacio});
                        await delay(500);

                        if (res.data && res.data.error) {
                            setLoading(false);
                            setUISweetAlert({
                                ...sweetAlertDefault,
                                error_dlg: true,
                                dynamic_title: "Fallo",
                                dynamic_description: res.data.message ? res.data.message : "",
                            });
                        } else {
                            setLoading(false);
                        }
                        setLoading(false);
                    } catch (error) {
                        setLoading(false);
                        setUISweetAlert({
                            ...sweetAlertDefault,
                            error_dlg: true,
                            dynamic_title: "Fallo",
                            dynamic_description: "Error en el servidor",
                        });
                    }
                });
            } else if (espaciosAtencionDefault && espaciosAtencionDefault.length > 0 && !opcionesExtras.seleccionarTodosEspacios) {
                espaciosAtencionDefault.forEach(async (espacio) => {
                    // eslint-disable-next-line
                    try {
                        const res = await exportAgenda({...filtrosImpresion, espacioVo: espacio});
                        if (res.data && res.data.error) {
                            setLoading(false);
                            setUISweetAlert({
                                ...sweetAlertDefault,
                                error_dlg: true,
                                dynamic_title: "Fallo",
                                dynamic_description: res.data.message ? res.data.message : "",
                            });
                        } else {
                            setLoading(false);
                        }
                        setLoading(false);
                    } catch (error) {
                        setLoading(false);
                        setUISweetAlert({
                            ...sweetAlertDefault,
                            error_dlg: true,
                            dynamic_title: "Fallo",
                            dynamic_description: "Error en el servidor",
                        });
                    }
                });
            } else if (opcionesExtras.seleccionarTodosEspacios) {
                espaciosAtencionAgenda.forEach(async (espacio) => {
                    // eslint-disable-next-line
                    try {
                        const res = await exportAgenda({...filtrosImpresion, espacioVo: espacio});
                        await delay(500);
                        
                        if (res.data && res.data.error) {
                            setLoading(false);
                            setUISweetAlert({
                                ...sweetAlertDefault,
                                error_dlg: true,
                                dynamic_title: "Fallo",
                                dynamic_description: res.data.message ? res.data.message : "",
                            });
                        } else {
                            setLoading(false);
                        }
                    } catch (error) {
                        setLoading(false);
                        setUISweetAlert({
                            ...sweetAlertDefault,
                            error_dlg: true,
                            dynamic_title: "Fallo",
                            dynamic_description: "Error en el servidor",
                        });
                    }
                });
            }
        } else if (filtrosImpresion.porDia && filtrosImpresion.fechaImpresion) {
            setLoading(true);
            try {
                const res = await exportAgendaPorDia({
                    fechaBusqueda: filtrosImpresion.fechaImpresion,
                    todosEspacios: opcionesExtras.seleccionarTodosEspacios ? opcionesExtras.seleccionarTodosEspacios : false,
                    todosPacientes: opcionesExtras.seleccionarTodosPacientes ? opcionesExtras.seleccionarTodosPacientes : false,
                    porDia: filtrosImpresion.porDia,
                    incluirTratamientos: filtrosImpresion.incluirTratamientos,
                    incluirCitas: filtrosImpresion.incluirCitas,
                    porAseguradora: opcionesExtras.porAseguradora ? opcionesExtras.porAseguradora : false,
                    espaciosVo: opcionesExtras.seleccionarTodosEspacios ? null : filtroCitasEspacios,
                });
                if (res.data && res.data.error) {
                    setLoading(false);
                    setUISweetAlert({
                        ...sweetAlertDefault,
                        error_dlg: true,
                        dynamic_title: "Fallo",
                        dynamic_description: res.data.message ? res.data.message : "",
                    });
                } else {
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                setUISweetAlert({
                    ...sweetAlertDefault,
                    error_dlg: true,
                    dynamic_title: "Fallo",
                    dynamic_description: "Error en el servidor",
                });
            }
        } else {
            setUISweetAlert({
                ...sweetAlertDefault,
                error_dlg: true,
                dynamic_title: "Fallo",
                dynamic_description: "Por favor, elige la fecha y los espacios a imprimir.",
            });
        }
        // exportAgenda({ ...filtrosImpresion, espacios: espaciosImpresion });
    };

    const onChangeFiltroImpresion = (e) => {
        const {name, value, checked} = e.target;
        if (name == "porDia") {
            setFiltrosImpresion({
                ...filtrosImpresion,
                [name]: checked,
            });
        } else if (name == "incluirTratamientos") {
            if (!filtrosImpresion.incluirCitas && !checked) {
                return;
            } else if (opcionesExtras.seleccionarTodosEspacios) {
                return;
            }
            setFiltrosImpresion({
                ...filtrosImpresion,
                [name]: checked,
            });
        } else if (name == "incluirCitas") {
            if (!filtrosImpresion.incluirTratamientos && !checked) {
                return;
            } else if (opcionesExtras.seleccionarTodosEspacios) {
                return;
            }
            setFiltrosImpresion({
                ...filtrosImpresion,
                [name]: checked,
            });
        } else if (name == "fechaImpresion") {
            if (filtrosImpresion.fechaImpresionFinal && value > filtrosImpresion.fechaImpresionFinal) {
                setFiltrosImpresion({
                    ...filtrosImpresion,
                    [name]: value,
                    fechaImpresionFinal: value,
                });
            } else {
                setFiltrosImpresion({
                    ...filtrosImpresion,
                    [name]: value,
                });
            }
        } else {
            setFiltrosImpresion({
                ...filtrosImpresion,
                [name]: value,
            });
        }
    };

    const historicoPacientes = () => {
        setAutoPause(true);
        setUISweetAlert({
            ...sweetAlertDefault,
            confirm_historico_paciente: true,
        });
    };

    const autorizado =
        usuario &&
        (usuario.authorities.includes("ROLE_RECEPCION") ||
            usuario.authorities.includes("ROLE_MEDICO") ||
            usuario.authorities.includes("ROLE_ASISTENTE") ||
            usuario.authorities.includes("ROLE_ADMIN_SISTEMA"));

    const autorizadoHistorico = usuario;

    const checkPermisosCalendario = () => {
        if (autorizado && banCrearCitas) {
            setAutoPause(true);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_alert_cita: true,
            });
        } else {
            setAutoPause(true);
            setUISweetAlert({
                ...sweetAlertDefault,
                confirm_alert_cita_no_autorizado: true,
            });
        }
    };

    const changeOpcionesExtras = async (e) => {
        const { name } = e.target;
        // OJO: no reasignar e.target.checked; usa una copia mutable
        let inputChecked = e.target.checked;
        const inputValue  = e.target.value;
      
        if (name === "seleccionarTodosEspacios") {
          setOpcionesExtras({ ...opcionesExtras, [name]: inputChecked });
      
          if (inputChecked) {
            setFiltrosImpresion({ ...filtrosImpresion, incluirCitas: true, incluirTratamientos: true });
            setExistenFiltros(false);
          } else {
            if (filtroCitasEspacios && filtroCitasEspacios.length > 0) setExistenFiltros(true);
            else setExistenFiltros(false);
          }
      
          setLoading(true);
          setAutoPause(true);
          try {
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              inputChecked = false; // forzamos solo-espacio cuando es médico/asistente
            }
      
            // === 3B: sincroniza rango/filtros para el timer ===
            const { viewStart, viewEnd } =
              (typeof getViewRange === "function" && getViewRange()) || {
                viewStart: filtrosRef.current.viewStart,
                viewEnd:   filtrosRef.current.viewEnd,
              };
      
            filtrosRef.current = {
              viewStart,
              viewEnd,
              espaciosVo: filtroCitasEspacios || [],
              pacientesVo: filtroCitasPacientes || [],
              aseguradorasVo: opcionesAseguradoras || [],
              todosEspacios: !!inputChecked,
              todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
              porAseguradora: !!opcionesExtras.porAseguradora,
              incluirTratamientos: false,
              incluirCitas: false,
            };
            // ==================================================
      
            const res = await listarCitas(
              fechaActual,
              filtroCitasEspacios,
              filtroCitasPacientes,
              opcionesAseguradoras,
              inputChecked,
              opcionesExtras.seleccionarTodosPacientes,
              opcionesExtras.porAseguradora
            );
      
            if (esAsistente || esMedico) {
              // restaura
              inputChecked = temporal;
            }
      
            await delay(delayTime);
            setLoading(false);
            setAutoPause(false);
            return res;
          } catch (error) {
            setLoading(false);
            setAutoPause(false);
          }
        } else if (name === "seleccionarTodosPacientes") {
          setOpcionesExtras({ ...opcionesExtras, [name]: inputChecked });
          setAutoPause(true);
          setLoading(true);
          try {
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              opcionesExtras.seleccionarTodosEspacios = false;
            }
      
            // === 3B: sincroniza rango/filtros para el timer ===
            const { viewStart, viewEnd } =
              (typeof getViewRange === "function" && getViewRange()) || {
                viewStart: filtrosRef.current.viewStart,
                viewEnd:   filtrosRef.current.viewEnd,
              };
      
            filtrosRef.current = {
              viewStart,
              viewEnd,
              espaciosVo: filtroCitasEspacios || [],
              pacientesVo: filtroCitasPacientes || [],
              aseguradorasVo: opcionesAseguradoras || [],
              todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
              todosPacientes: !!inputChecked,
              porAseguradora: !!opcionesExtras.porAseguradora,
              incluirTratamientos: false,
              incluirCitas: false,
            };
            // ==================================================
      
            const res = await listarCitas(
              fechaActual,
              filtroCitasEspacios,
              filtroCitasPacientes,
              opcionesAseguradoras,
              opcionesExtras.seleccionarTodosEspacios,
              inputChecked,
              opcionesExtras.porAseguradora
            );
      
            if (esAsistente || esMedico) {
              opcionesExtras.seleccionarTodosEspacios = temporal;
            }
      
            await delay(delayTime);
            setLoading(false);
            setAutoPause(false);
            return res;
          } catch (error) {
            setLoading(false);
            setAutoPause(false);
          }
        } else if (name === "porAseguradora") {
          setOpcionesExtras({ ...opcionesExtras, [name]: inputChecked });
      
          setLoading(true);
          setAutoPause(true);
          try {
            let temporal = false;
            if (esMedico || esAsistente) {
              temporal = opcionesExtras.seleccionarTodosEspacios;
              opcionesExtras.seleccionarTodosEspacios = false;
            }
      
            // === 3B: sincroniza rango/filtros para el timer ===
            const { viewStart, viewEnd } =
              (typeof getViewRange === "function" && getViewRange()) || {
                viewStart: filtrosRef.current.viewStart,
                viewEnd:   filtrosRef.current.viewEnd,
              };
      
            filtrosRef.current = {
              viewStart,
              viewEnd,
              espaciosVo: filtroCitasEspacios || [],
              pacientesVo: filtroCitasPacientes || [],
              aseguradorasVo: opcionesAseguradoras || [],
              todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
              todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
              porAseguradora: !!inputChecked,
              incluirTratamientos: false,
              incluirCitas: false,
            };
            // ==================================================
      
            const res = await listarCitas(
              fechaActual,
              filtroCitasEspacios,
              filtroCitasPacientes,
              opcionesAseguradoras,
              opcionesExtras.seleccionarTodosEspacios,
              opcionesExtras.seleccionarTodosPacientes,
              inputChecked
            );
      
            if (esAsistente || esMedico) {
              opcionesExtras.seleccionarTodosEspacios = temporal;
            }
      
            await delay(delayTime);
            setAutoPause(false);
            setLoading(false);
            return res;
          } catch (error) {
            setAutoPause(false);
            setLoading(false);
          }
        } else {
          // otros switches/cambios de opciones
          setOpcionesExtras({ ...opcionesExtras, [name]: inputValue });
        }
    };
      

    /*  EN ESTA PARTE SE HACE EL FILTRO POR DOCTOR PARA QUE NADA MAS PUEDA VER SUS CONSULTAS  */
    const seleccionarEspaciosAtencionDefault = (espaciosFetched) => {
        const espaciosDefault = espaciosFetched.filter((espacio) => {
            if (esAsistente){
                if (espacio.idAsistente == usuario.idCatUsuario){
                    return espacio;
                }
            }else{
                return espacio.idCatMedico == usuario.idCatMedico;
            } 
        });
        setEspaciosAtencionDefault(espaciosDefault);
        return espaciosDefault;
    };

    // Método para checar si hay espacios de tipo médico en los espacios seleccionados
    const checkHorarioEspacio = (espacios) => {
        let horarioMin = null;
        let horarioMinInt = null;
        if (espacios && espacios.length == 1) {
            if (espacios[0].semana && espacios[0].semana.length > 0) {
                espacios[0].semana.forEach((dia) => {
                    if (dia.horarios && dia.horarios.length > 0 && dia.horarios[0] && dia.horarios[0].disponible) {
                        if (horarioMin == null) {
                            horarioMin = dia.horarios[0].inicio;
                            horarioMinInt = parseInt(dia.horarios[0].inicio.split(":")[0]);
                        } else {
                            let horarioMinTemp = parseInt(dia.horarios[0].inicio.split(":")[0]);
                            if (horarioMinInt > horarioMinTemp) {
                                horarioMin = dia.horarios[0].inicio;
                                horarioMinInt = parseInt(dia.horarios[0].inicio.split(":")[0]);
                            }
                        }
                    }
                });
            }
        } else {
            horarioMin = "06:00:00";
        }
        setHorarioMinimoCalendario(horarioMin);
    };

    const renderCalendar = useMemo(() => {
        return (
            <FullCalendar
                timeZone="America/Mexico_City"
                //utc={true}
                plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
                ref={calendarComponentRef}
                initialView="timeGridWeek"
                navLinks={true}
                nowIndicator={true}
                progressiveEventRendering={false}
                dayMaxEventRows={5}
                eventMaxStack={2}
                autoComplete="off" 
                editable={true}
                eventDrop={cambioHoraCita}
                eventResize={cambioHoraCita}
                slotMinTime={horarioMinimoCalendario ? horarioMinimoCalendario : "06:00:00"}
                slotMaxTime={"23:59:00"}
                slotEventOverlap={true}
                eventLimit={1}
                slotDuration={"00:15:00"}
                allDaySlot={false}
                className="fc-event-title fc-event "
                eventStack={true}
                weekends={mostrarFinDeSemana}
                eventSources={[
                    !banOcultarCalendario?{
                        events: citas,
                        color: "#000000",
                        // color: 'green',
                    }:false
                ]}
                headerToolbar={{
                    left: "prev,next today nuevoEvento nuevoPaciente",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                buttonText={{
                    today: "Hoy",
                    month: "Mes",
                    week: "Semana",
                    day: "Día",
                }}
                customButtons={{
                    nuevoEvento: {
                        text: "Nueva Cita",
                        click: () => {
                            checkPermisosCalendario();
                        },
                    },
                    nuevoPaciente: {
                        text: "Nuevo Paciente",
                        click: () => {
                            nuevoPacienteRedirect();
                        },
                    },
                }}
                initialDate={new Date()}
                dateClick={autorizado ? nuevaCitaFechaSeleccionada : null}
                eventClick={editCitaConfirm}
                viewDidMount={viewchange}
                datesSet={(info) => changeFecha(info)}
                locale="es"

                eventDidMount={(info) => {
                    const { event, el } = info;
                  
                    el.addEventListener('mousemove', (e) => {
                      if (!calendarWrapperRef.current) return; // protección por si el ref no está listo
                  
                    const pacienteNombre = TraePacienteNombre(event.extendedProps.paciente);

                    let medicoNombre;
                    if (!event.extendedProps.idCatMedico || event.extendedProps.idCatMedico === 0) {
                        medicoNombre = TraeEspacioMedico(event.extendedProps.espacio);
                    } else {
                        medicoNombre = TraeMedico(event.extendedProps.idCatMedico);
                    }
                    

                    const detalles = 
                    `<div><strong>Id:</strong> ${event.id}</div>` +
                    `<div><strong>Médico:</strong> ${medicoNombre}</div>` +
                    `<div><strong>Paciente:</strong> ${pacienteNombre}</div>` +
                    `<div><strong>Hora:</strong> ${event.extendedProps.horaInicioStr} - ${event.extendedProps.horaFinStr}</div>` +
                    `<div><strong>Comentario Recepción:</strong> ${event.extendedProps.comentarioRecepcion || 'Sin comentarios'}</div>`;
                                        
                      const offsetX = 10;
                      const offsetY = 10;
                  
                      const calendarRect = calendarWrapperRef.current.getBoundingClientRect();
                  
                      const left = e.clientX - calendarRect.left + offsetX;
                      const top = e.clientY - calendarRect.top + offsetY;
                  
                      setTooltipContent(detalles);
                      setTooltipPosition({ top, left });
                      setShowTooltip(true);
                    });
                  
                    el.addEventListener('mouseleave', () => {
                      setShowTooltip(false);
                    });
                }}                                              
            />
        );
    }, [citas, pacientes]);
   
    return (
        <>
            {usuario &&
            (usuario.authorities.includes("OP_CONSULTA_CALENDARIO") ||
                usuario.authorities.includes("ROLE_CONTABILIDAD") ||
                usuario.authorities.includes("ROLE_FARMACIA") ||
                usuario.authorities.includes("ROLE_ASEGURADORAS") ||
                usuario.authorities.includes("ROLE_ASISTENTE") ||
                usuario.authorities.includes("ROLE_MEDICO")  ||
                usuario.authorities.includes("ROLE_ADMIN_SISTEMA") ||
                usuario.authorities.includes("ROL_AUXILIAR_ADMINISTRACION") ||
                usuario.authorities.includes("ROLE_COMPRAS") ) ? (
                <>
                    {}
                    <div className="mt-8" style={{textAlign: "left"}}>
                        <h3 className="flex h3 ">Agenda</h3>
                        <Card className="mt-4">
                            <CardBody>
                                <Row>
                                    <Col xl={6} lg={12} md={20}>
                                        <Row className="form-group">
                                            <label className="col-sm-3 col-form-label">Espacios de atención</label>
                                            <Col sm={9}>
                                                <WindowedSelect
                                                    isDisabled={
                                                        opcionesExtras.seleccionarTodosEspacios || (esMedicoNoAdministrador && !esMedicoConRoleAgenda)
                                                    }
                                                    isSearchable
                                                    options=  
                                                    {
                                                        esAsistente?
                                                        (
                                                             espaciosAtencionAgenda.filter((espacios) => espacios.idAsistente == usuario.idCatUsuario)
                                                        ) : (
                                                            esMedicoNoAdministrador && !esMedicoConRoleAgenda
                                                            ? espaciosAtencionAgenda.filter((espacios) => espacios.idCatMedico == usuario.idCatMedico)
                                                            : espaciosAtencionAgenda
                                                        )
                                                    }
                                                    isMulti
                                                    autoComplete="off" 
                                                    getOptionLabel={(option) => option.espacio}
                                                    getOptionValue={(option) => option.idEspacio}
                                                    // styles={colourStyles}
                                                    value={
                                                        esMedicoNoAdministrador && !esMedicoConRoleAgenda? espaciosAtencionDefault 
                                                        : filtroCitasEspacios
                                                    }
                                                    menuPortalTarget={document.body}
                                                    menuPosition={"fixed"}
                                                    onChange={(option) => changeEspacioFiltro(option)}
                                                    noOptionsMessage={() => "No hay opciones"}
                                                    placeholder="Seleccione una opción"
                                                />
                                            </Col>
                                        </Row>
                                        {(banMostrarObjetos)? (
                                            <Row className="form-group">
                                                <label className="col-sm-3 col-form-label">Todos los espacios</label>
                                                <Col sm={2}>
                                                    <input
                                                        disabled={esMedicoNoAdministrador && !esMedicoConRoleAgenda}
                                                        autoComplete="off" 
                                                        type="checkbox"
                                                        name="seleccionarTodosEspacios"
                                                        className="form-control"
                                                        onChange={changeOpcionesExtras}
                                                        checked={opcionesExtras.seleccionarTodosEspacios}
                                                    />
                                                </Col>
                                            </Row>
                                        ) : null}
                                    </Col>
                                    <Col xl={6} lg={12} md={20}>
                                        <Row className="form-group">
                                            <label className="col-sm-3 col-form-label">Pacientes</label>
                                            <Col sm={9}>
                                                <SelectPacientesPaginado
                                                    opcionSeleccionadaCompleta={opcionesPacientes}
                                                    onChangeOptions={changePacientesFiltro}
                                                    fetchOptions={loadPacientesSelect}
                                                    opcionesPaginado={opcionesSelectPacientes.opcionesPaginado}
                                                    placeholderText={opcionesSelectPacientes.placeholderText}
                                                    optionLabel={opcionesSelectPacientes.optionLabel}
                                                    optionValue={opcionesSelectPacientes.optionValue}
                                                    isDisabled={esMedico || esAsistente? false :  opcionesExtras.seleccionarTodosPacientes}
                                                    isMulti={true}
                                                />    
                                                {}
                                            </Col>
                                            {/*  TODO: */}
                                            {usuario.authorities.includes("ROLE_ASEGURADORAS") ? (
                                                <>
                                                <label className="col-sm-3 col-form-label">Aseguradoras</label>
                                                <Col sm={9}>
                                                    <WindowedSelect
                                                        isDisabled={!opcionesExtras.porAseguradora}
                                                        isSearchable
                                                        options= {aseguradoras.filter((aseguradoaInterno) => aseguradoaInterno.activo == true) }
                                                        isMulti
                                                        autoComplete="off" 
                                                        getOptionLabel={(option) => option.aseguradora}
                                                        getOptionValue={(option) => option.idCatAseguradora}
                                                        // styles={colourStyles}
                                                        value={filtroCitasAseguradoras}
                                                        menuPortalTarget={document.body}
                                                        menuPosition={"fixed"}
                                                        onChange={(option) => changeAseguradoraFiltro(option)}
                                                        noOptionsMessage={() => "No hay opciones"}
                                                        placeholder="Seleccione una opción"
                                                    />   
                                                    {}
                                                </Col>    
                                            </>
                                            ) :null}                                                                                    
                                            {(banMostrarObjetos) ? (
                                                <>
                                                    <label className="col-sm-3 col-form-label">Pacientes con aseguradora</label>
                                                    <Col sm={2}>
                                                        <input
                                                            type="checkbox"
                                                            autoComplete="off" 
                                                            name="porAseguradora"
                                                            className="form-control"
                                                            onChange={changeOpcionesExtras}
                                                            checked={opcionesExtras.porAseguradora}
                                                        />
                                                    </Col>
                                                    <label className="col-sm-3 col-form-label">Todos los pacientes</label>
                                                    <Col sm={2}>
                                                        <input
                                                            type="checkbox"
                                                            autoComplete="off" 
                                                            name="seleccionarTodosPacientes"
                                                            className="form-control"
                                                            onChange={changeOpcionesExtras}
                                                            checked={opcionesExtras.seleccionarTodosPacientes}
                                                        />
                                                    </Col>
                                                </>
                                            ) :null}
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card className="mt-4">
                            <CardBody className="flex flex-col md:flex-row justify-center md:justify-start">
                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light md:mr-3"
                                    type="button"
                                    onClick={imprimirAgenda}
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        height:42,      
                                        margin:5,    
                                        padding:7,                              
                                    }}>
                                    Imprimir Agenda
                                </button>

                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light"
                                    type="button"
                                    onClick = {visualizarDiaCitasGeneral}                                    
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        margin:5,
                                        height:42,
                                        padding:7,
                                    }}>
                                    Ver Agenda
                                </button>  

                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light"
                                    type="button"
                                    onClick={RefreshCalendar}
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        margin:5,
                                        height:42,
                                        padding:7,
                                    }}>
                                    Recargar Agenda
                                </button>  

                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light"
                                    type="button"
                                    onClick={RefreshCalendarChanges}
                                    hidden = {true}
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        margin:5,
                                        height:42,
                                        padding:7,
                                    }}>
                                    Recargar Agenda cambios
                                </button>                                   

                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light"
                                    type="button"
                                    onClick={historicoPacientes}
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        height:42,    
                                        margin:5,    
                                        padding:7,                                
                                    }}>
                                    Histórico de Pacientes
                                </button>
  
                                <button
                                    className="btn btn-primary-purple-umo w-md waves-effect waves-light"
                                    type="button"
                                    onClick = {visualizarDiaCitas}                                    
                                    style={{
                                        background: "#ff9933",
                                        color: "white",
                                        marginTop: "1rem",
                                        fontWeight: "bold",
                                        margin:5,
                                        height:42,
                                        padding:7,
                                    }}>
                                    Pantalla de Agenda
                                </button>                                                                                                                            
                                {}
                            </CardBody>
                        </Card>
                    </div>
                    <div ref={calendarWrapperRef} style={{ position: 'relative' }}>
                    {renderCalendar}

                    {showTooltip && (
                    <div
                        style={{
                        position: 'absolute',
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '8px',
                        borderRadius: '4px',
                        zIndex: 9999,
                        pointerEvents: 'none',
                        maxWidth: '300px',
                        fontSize: '14px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        whiteSpace: 'normal',
                        textAlign: 'left', // 👈 aquí la alineación
                        }}
                        dangerouslySetInnerHTML={{ __html: tooltipContent }}
                    />
                    )}
                    </div>

                    {}

                    {UISweetAlert.confirm_alert_cita ? (
                        <SweetAlert
                            title={UISweetAlert.editar ? "Editar Cita" : "Nueva Cita"}
                            warning
                            showCancel
                            showConfirm={autorizado || tienePermisoAseguradoras || esFarmacia}
                            confirmBtnText="Continuar"
                            confirmBtnBsStyle="success"
                            cancelBtnText="Cancelar"
                            cancelBtnBsStyle="danger"
                            closeOnClickOutside={false}
                            style={{
                                width: width && width < 851 ? "100%" : "65%",
                            }}
                            onConfirm={() => checkUploadCita()}
                            onCancel={() => {
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                                setCitaSeleccionada({
                                    start: formatDate(new Date(), true),
                                    end: formatDate(new Date(new Date().getTime() + tiempoCita), true),
                                });
                                setDisabledEditar(false);
                                LimpiarDatos();
                                setAutoPause(false);
                            }}>
                            <div hidden={UISweetAlert.editar ? false : true}>
                                <Row>
                                    <Col sm={11} style={{textAlign: "right"}}>
                                        <button
                                            hidden={!autorizado}
                                            onClick={confirmEliminarCita}
                                            type="button"
                                            className="btn btn-primary-blue-umo w-md waves-effect waves-light">
                                            Eliminar Cita
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Espacio/Médico<span className="text-xs text-red-700">*</span>
                                    </label>
                                    <Col sm={8}>
                                        <select
                                            className="form-control"
                                            autoComplete="off" 
                                            disabled={!autorizado}
                                            name="espacio"
                                            onChange={onChangeNuevaCita}
                                            value={citaSeleccionada.espacio}>
                                            <option selected disabled value={""}>
                                                Seleccione una opción
                                            </option>
                                            {
                                                esAsistente || existenFiltros?(
                                                    espaciosFiltrados.map((espacio) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    key={espacio.idEspacio}
                                                                    disabled={false}
                                                                    hidden={(usuario.idCatMedico && usuario.idCatMedico != espacio.idCatMedico) 
                                                                        || espacio.idCatTipoEspacio == 4}
                                                                    value={espacio.idEspacio}>
                                                                    {espacio.espacio}
                                                                </option>
                                                            </>
                                                        );  
                                                    })
                                                )
                                                : (
                                                    espaciosAtencionAgenda.map((espacio) => {
                                                        return (
                                                            <>
                                                                {(esMedicoNoAdministrador && usuario.idCatMedico == espacio.idCatMedico) ||
                                                                !esMedicoNoAdministrador ? (
                                                                    <option
                                                                        key={espacio.idEspacio}
                                                                        disabled={(esMedicoNoAdministrador && usuario.idCatMedico != espacio.idCatMedico) 
                                                                            || espacio.idCatTipoEspacio == 4 }
                                                                        hidden={(usuario.idCatMedico && usuario.idCatMedico != espacio.idCatMedico) 
                                                                            || espacio.idCatTipoEspacio == 4}
                                                                        value={espacio.idEspacio}>
                                                                        {espacio.espacio}
                                                                    </option>
                                                                ) : null}
                                                            </>
                                                        );
                                                    })
                                                )
                                            }
                                        </select>
                                        {(citaSeleccionada.espacio === "" || !citaSeleccionada.espacio) && (
                                            <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                        )}
                                    </Col>
                                </Row>
                                {citaSeleccionada && citaSeleccionada.tipoEspacio != 1 ? 
                                (
                                <Row className="form-group mt-3">
                                        <label className="col-sm-2 col-form-label">
                                            Título<span className="text-xs text-red-700">*</span>
                                        </label>
                                    <Col sm={10}>
                                       {UISweetAlert && citaSeleccionada.tipoEspacio != 2 ? (
                                                <input
                                                    type="text"
                                                    autoComplete="off" 
                                                    disabled={true}
                                                    className="form-control"
                                                    name="title"
                                                    onChange={onChangeNuevaCita}
                                                    // value={UISweetAlert.editar ? citaSeleccionada.description : citaSeleccionada.title}
                                                    value={tituloFormatear()}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    autoComplete="off" 
                                                    disabled={!autorizado}
                                                    className="form-control"
                                                    name="title"
                                                    onChange={onChangeNuevaCita}
                                                    // value={UISweetAlert.editar ? citaSeleccionada.description : citaSeleccionada.title}
                                                    value={citaSeleccionada.title}
                                                />
                                            )}
                                            {(citaSeleccionada.title === "" || !citaSeleccionada.title) && citaSeleccionada.tipoEspacio == 2 && (
                                                <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                            )}
                                    </Col>
                                </Row>
                                ) : null}
                                <Row>

                                </Row>
                                {citaSeleccionada.todoDia ? 
                                (
                                    <Row className="form-group mt-2">
                                        <label className="col-sm-4 col-form-label"> 
                                            Fecha
                                        </label>
                                        <Col sm={3}>
                                            <input
                                                type="date"
                                                autoComplete="off" 
                                                disabled={!autorizado}
                                                className="form-control"
                                                name="start"
                                                onChange={onChangeNuevaCita}
                                                value={citaSeleccionada.start ? formatDate(citaSeleccionada.start, false, citaSeleccionada.todoDia) : ""}
                                            />
                                            {/* <MuiPickersUtilsProvider disabled={!autorizado} locale="es" utils={DayjsUtils} className="form-control">
                                                <DateTimePicker
                                                fullWidth
                                                // format="dd/MM/yyyy"
                                                // label="Date of birth"
                                                disabled={!autorizado}
                                                value={citaSeleccionada.start ? citaSeleccionada.start : ""}
                                                onChange={changeFechaInicalNuevaCita}
                                                />
                                            </MuiPickersUtilsProvider> */}
                                        </Col>
                                        <Col sm={3}>
                                        <FormControlLabel
                                                disabled={!autorizado}
                                                control={
                                                    <Switch
                                                        defaultChecked={false}
                                                        onChange={onChangeNuevaCita}
                                                        checked={citaSeleccionada.todoDia ? citaSeleccionada.todoDia : false}
                                                        color="primary"
                                                        name="todoDia"
                                                    />
                                                }
                                                label="Todo el Día"
                                            /> 
                                        </Col>                                       
                                    </Row>
                                ) : (
                                    <>
                                        {/******************  ESPACIO PARA CONSULTORIO ********************** */}
                                        {UISweetAlert.editar  && citaSeleccionada.tipoEspacio == 1 ? 
                                        (
                                        <Row className="form-group mt-2" >
                                            <label className="col-sm-4 col-form-label">
                                            Consultorio
                                            </label>                                     
                                            <Col  sm={4}>
                                                    <input
                                                        disabled={true}
                                                        autoComplete="off" 
                                                        className="form-control"
                                                        name="consultorio"
                                                        rows={8}
                                                        // value={UISweetAlert.editar ? citaSeleccionada.description : citaSeleccionada.title}
                                                        value={citaSeleccionada.consultorio}
                                                    />  
                                            </Col>
                                        </Row>
                                        ):null}

                                        <Row >
                                        <Col  sm={10}>
                                            <label className="col-sm-2 col-form-label">
                                                Fecha Inicio<span className="">*</span>
                                            </label>
                                                {/* <input type={} /> */}
                                                <input
                                                    type="datetime-local"
                                                    autoComplete="off" 
                                                    className=""
                                                    value={citaSeleccionada.start ? citaSeleccionada.start : ""}
                                                    disabled={!autorizado}
                                                    onChange={(e) => changeFechaInicalNuevaCita(e)}
                                                />
                                                {/* <MuiPickersUtilsProvider disabled={!autorizado} locale="es" utils={DayjsUtils} className="form-control">
                                                <DateTimePicker
                                                    fullWidth
                                                    disabled={!autorizado}
                                                    value={citaSeleccionada.start ? citaSeleccionada.start : ""}
                                                    onChange={changeFechaInicalNuevaCita}
                                                />
                                                </MuiPickersUtilsProvider> */}

                                            <label className="col-sm-2 col-form-label">
                                                Fecha Final<span className="text-xs text-red-700">*</span>
                                            </label>

                                                <input
                                                    type="datetime-local"
                                                    autoComplete="off" 
                                                    className=""
                                                    value={citaSeleccionada.end ? citaSeleccionada.end : ""}
                                                    disabled={!autorizado}
                                                    onChange={(e) => changeFechaFinalNuevaCita(e)}
                                                />
                                                {/* <MuiPickersUtilsProvider disabled={!autorizado} locale="es" utils={DayjsUtils} className="form-control">
                                                    <DateTimePicker
                                                        fullWidth
                                                        disabled={!autorizado}
                                                        value={citaSeleccionada.end ? citaSeleccionada.end : ""}
                                                        onChange={changeFechaFinalNuevaCita}
                                                    />
                                                    </MuiPickersUtilsProvider> */}
                                            </Col>
                                            <FormControlLabel
                                                disabled={!autorizado}
                                                control={
                                                    <Switch
                                                        defaultChecked={false}
                                                        onChange={onChangeNuevaCita}
                                                        checked={citaSeleccionada.todoDia ? citaSeleccionada.todoDia : false}
                                                        color="primary"
                                                        name="todoDia"
                                                    />
                                                }
                                                label="Todo el Día"
                                            />

                                        </Row>
                                    </>
                                )}

                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Tipo de Cita<span className="text-xs text-red-700">*</span>
                                    </label>
                                    <Col sm={8}>
                                        <select
                                            disabled={!autorizado}
                                            autoComplete="off" 
                                            className="form-control"
                                            name="idCatTipoCita"
                                            onChange={onChangeNuevaCita}
                                            value={citaSeleccionada.idCatTipoCita}>
                                            <option selected disabled value="">
                                                Seleccione una opción
                                            </option>
                                            {tipoCitas &&
                                                tipoCitas.map((tipoCita) => {
                                                    return (
                                                        <>
                                                            {  
                                                                !esAsistente ?
                                                                (
                                                                    esMedicoNoAdministrador ? 
                                                                    (
                                                                        tipoCita.medico ? (
                                                                            <option key={tipoCita.idCatTipoCita} value={tipoCita.idCatTipoCita}>
                                                                                {tipoCita.tipoCita}
                                                                            </option>
                                                                        ) : null
                                                                    ) : 
                                                                    (
                                                                        <option key={tipoCita.idCatTipoCita} value={tipoCita.idCatTipoCita}>
                                                                            {tipoCita.tipoCita}
                                                                        </option>
                                                                )
                                                                ) : 
                                                                (
                                                                    tipoCita.asistente ?  (
                                                                        <option key={tipoCita.idCatTipoCita} value={tipoCita.idCatTipoCita}>
                                                                            {tipoCita.tipoCita}
                                                                        </option>
                                                                    ) : null
                                                                )
                                                            }
                                                        </>
                                                    );
                                                })}
                                        </select>
                                        {(citaSeleccionada.idCatTipoCita === "" || !citaSeleccionada.idCatTipoCita) && (
                                            <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                        )}
                                    </Col>
                                </Row>
                                {citaSeleccionada.tipoEspacio && citaSeleccionada.tipoEspacio == 3 ? (
                                    <Row className="form-group mt-2">
                                        <label className="col-sm-4 col-form-label">
                                            Médico<span className="text-xs text-red-700">*</span>
                                        </label>
                                        <Col sm={8}>
                                            <select
                                                disabled={!autorizado}
                                                autoComplete="off" 
                                                className="form-control"
                                                name="idCatMedico"
                                                onChange={onChangeNuevaCita}
                                                value={citaSeleccionada.idCatMedico}>
                                                <option selected disabled value="">
                                                    Seleccione una opción
                                                </option>
                                                {medicos &&
                                                    medicos.map((medico) => {
                                                        return (
                                                            <>
                                                                <option key={medico.idCatMedico} value={medico.idCatMedico}>{`${
                                                                    medico.prefijo ? medico.prefijo : ""
                                                                } ${medico.catPersona.nombres} ${medico.catPersona.apellidoPaterno} ${
                                                                    medico.catPersona.apellidoMaterno
                                                                }`}</option>
                                                            </>
                                                        );
                                                    })}
                                            </select>
                                        </Col>
                                    </Row>
                                ) : null}

                                <Row className="form-group mt-2" hidden={!citaSeleccionada.tipoEspacio || citaSeleccionada.tipoEspacio == 2}>
                                    <label className="col-sm-4 col-form-label">
                                        Paciente<span className="text-xs text-red-700">{citaSeleccionada.idCatTipoCita != 11 ? "*" : ""}</span>
                                    </label>

                                    <Col sm={8}>
                                    {!citaSeleccionada.nombrePaciente? (
                                        <SelectPacientesPaginado
                                            opcionSeleccionadaCompleta={pacienteDeCitaSeleccionada}
                                            onChangeOptions={changePacienteNuevaCita}
                                            fetchOptions={loadPacientesSelect}
                                            opcionesPaginado={opcionesSelectPacientes.opcionesPaginado}
                                            placeholderText={opcionesSelectPacientes.placeholderText}
                                            optionLabel={opcionesSelectPacientes.optionLabel}
                                            optionValue={opcionesSelectPacientes.optionValue}
                                            isDisabled={!autorizado}
                                            isMulti={false}
                                            hidden = {citaSeleccionada.nombrePaciente? true:false}
                                            // opcionesExtras={{ menuPortalTarget: document.body, menuPosition: "fixed" }}
                                        />
                                    ):null}
                                        <input
                                            name="porAseguradora"
                                            autoComplete="off" 
                                            className="form-control-disabled"
                                            disabled={true}
                                            value={citaSeleccionada.nombrePaciente}
                                            hidden = {citaSeleccionada.nombrePaciente? false:true}
                                        />

                                        {/* <WindowedSelect
                                        isDisabled={!autorizado}
                                        isSearchable
                                        options={pacientes}
                                        getOptionLabel={(option) => `${option.nombres} ${option.apellidoPaterno} ${option.apellidoMaterno}`}
                                        getOptionValue={(option) => option.idCatPaciente}
                                        // styles={colourStyles}
                                        isClearable
                                        isMulti={false}
                                        // value={pacientes.filter((paciente) => paciente.idCatPaciente == citaSeleccionada.paciente)}
                                        value={pacienteDeCitaSeleccionada}
                                        menuPortalTarget={document.body}
                                        menuPosition={"fixed"}
                                        onChange={(option) => changePacienteNuevaCita(option)}
                                        noOptionsMessage={() => "No hay opciones"}
                                        placeholder="Seleccione un paciente"
                                        /> */}
                                        {citaSeleccionada.idCatTipoCita != 11
                                            ? (citaSeleccionada.paciente === "" || !citaSeleccionada.paciente) && (
                                            <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                        )
                                            : ""}
                                    </Col>
                                    
                                    
                                </Row>
                                <Row className="form-group mt-1" hidden={!citaSeleccionada.paciente ? true : false}>
                                    <Col sm={4} style={{textAlign:"left"}}>
                                        
                                    </Col>                                      
                                    <Col sm={5} style={{textAlign:"left"}}>
                                        <label width={200} >{comentarioPaciente}</label>
                                    </Col>   
                                    <Col sm={2} style={{textAlign:"right"}}>
                                        <button
                                            type="button"
                                            className="btn btn-primary-orange-umo w-md waves-effect waves-light"
                                            hidden={
                                                usuario.authorities.includes("OP_CATALOGO_PACIENTE_CREAR") ||
                                                usuario.authorities.includes("OP_CATALOGO_PACIENTE_MODIFICAR") ||
                                                usuario.authorities.includes("ROLE_ASEGURADORAS") 
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => expedienteMedicoPaciente()}>
                                            Expediente
                                        </button>

                                    </Col>
                                </Row>

                                {citaSeleccionada.idCatTipoCita &&
                                (citaSeleccionada.paciente == null || citaSeleccionada.paciente == "") &&
                                citaSeleccionada.tipoEspacio &&
                                citaSeleccionada.idCatTipoCita == 11 &&
                                citaSeleccionada.tipoEspacio == 1 &&
                                !UISweetAlert.editar ? (
                                    <>
                                        <Row >
                                            <label className="col-sm-4 col-form-label">
                                                Nombre del Paciente<span className="text-xs text-red-700">*</span>
                                            </label>
                                            <Col sm={4}>
                                                <input
                                                    disabled={!autorizado}
                                                    autoComplete="off" 
                                                    type="text"
                                                    placeholder="Escriba el nombre del paciente si no se encuentra en la lista de arriba"
                                                    className="form-control"
                                                    name="nombrePaciente"
                                                    onChange={onChangeDatosPaciente}
                                                    value={datosPaciente.nombrePaciente ? datosPaciente.nombrePaciente : ""}
                                                />
                                                {(datosPaciente.nombrePaciente === "" || !datosPaciente.nombrePaciente) && (
                                                    <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                                )}
                                            </Col>
                                            <label className="col-sm-2 col-form-label">
                                                Teléfono<span className="text-xs text-red-700">*</span>
                                            </label>
                                            <Col sm={2}>
                                                <input
                                                    type="text"
                                                    autoComplete="off" 
                                                    disabled={!autorizado}
                                                    className="form-control"
                                                    name="telefonoPaciente"
                                                    onChange={onChangeDatosPaciente}
                                                    value={datosPaciente.telefonoPaciente ? datosPaciente.telefonoPaciente : ""}
                                                />
                                                {(datosPaciente.telefonoPaciente === "" || !datosPaciente.telefonoPaciente) && (
                                                    <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                                )}
                                            </Col>
                                        </Row>
                                    </>
                                ) : null}
                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Comentarios Recepción<span className="text-xs text-red-700">*</span>
                                    </label>
                                    <Col sm={8}>
                                        <textarea
                                            autoComplete="off" 
                                            disabled={
                                                !autorizado && 
                                                !(
                                                    esAsistente &&
                                                    !tienePermisoAseguradoras &&
                                                    pacienteDeCitaSeleccionada &&
                                                    pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    (pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                        pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                )
                                            }    
                                            rows={3}
                                            className={
                                                !autorizado && 
                                                !(
                                                    esAsistente &&
                                                    !tienePermisoAseguradoras &&
                                                    pacienteDeCitaSeleccionada &&
                                                    pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    (pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                        pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                )?"form-control-disabled": "form-control"
                                            }    
                                            name="comentarioRecepcion"
                                            onChange={onChangeNuevaCita}
                                            value={citaSeleccionada.comentarioRecepcion}
                                        />
                                        {(citaSeleccionada.comentarioRecepcion === "" || !citaSeleccionada.comentarioRecepcion) && (
                                            <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Comentarios Aseguradora<span className="text-xs text-red-700">*</span>
                                    </label> 
                                    <Col sm={8}>
                                        <textarea maxLength="500"
                                            autoComplete="off" 
                                            disabled={
                                                esAsistente || esMedico ? true:(
                                                !autorizado && 
                                                !(
                                                    
                                                    puedeEditarComentarioAseguradora
                                                    //pacienteDeCitaSeleccionada &&
                                                    //pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    //(pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                    //    pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                ))
                                            }
                                            rows={3}    
                                            name="comentarioAseguradora"
                                            onChange={onChangeNuevaCita}
                                            className = {
                                                (esAsistente || esMedico ? true:(
                                                !autorizado && 
                                                !(
                                                    puedeEditarComentarioAseguradora
                                                    //pacienteDeCitaSeleccionada &&
                                                    //pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    //(pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                     //   pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                )))?"form-control-disabled": "form-control"
                                            }
                                            value={citaSeleccionada.comentarioAseguradora} 
                                        />

                                    </Col>  
                                </Row>   
                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Comentarios Farmacia<span className="text-xs text-red-700">*</span>
                                    </label>
                                    <Col sm={8}>
                                        <textarea maxLength="500"
                                            autoComplete="off" 
                                            disabled={!esFarmacia && !usuario.authorities.includes("ROLE_RECEPCION")}
                                            rows={3}
                                            className={
                                                (!esFarmacia && !usuario.authorities.includes("ROLE_RECEPCION"))?"form-control-disabled": "form-control"
                                            }
                                            name="comentarioFarmacia"
                                            onChange={onChangeNuevaCita}
                                            value={citaSeleccionada.comentarioFarmacia}
                                        />
                                    </Col>
                                </Row>       
                                <Row className="form-group mt-2">
                                    <label className="col-sm-4 col-form-label">
                                        Comentarios Tratamiento<span className="text-xs text-red-700">*</span>
                                    </label>
                                    <Col sm={8}>
                                        <textarea maxLength="500"
                                            autoComplete="off" 
                                            disabled={
                                                esAsistente || esMedico || esFarmacia? true:(
                                                !autorizado &&
                                                !(
                                                    !tienePermisoAseguradoras &&
                                                    pacienteDeCitaSeleccionada &&
                                                    pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    (pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                        pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                ) )
                                            }
                                            rows={3}
                                            className={
                                                (esAsistente || esMedico || esFarmacia ? true:(
                                                !autorizado &&  
                                                !(  
                                                    !tienePermisoAseguradoras &&
                                                    pacienteDeCitaSeleccionada &&
                                                    pacienteDeCitaSeleccionada.expedienteMedico &&
                                                    (pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora ||
                                                        pacienteDeCitaSeleccionada.expedienteMedico.idCatAseguradora == "")
                                                ) ))?"form-control-disabled": "form-control"
                                            }
                                            name="comentarioTratamiento"
                                            onChange={onChangeNuevaCita}
                                            value={citaSeleccionada.comentarioTratamiento}
                                        />
                                    </Col>
                                </Row>                      
                            </div> 
                        </SweetAlert>
                    ) : null}

                    {UISweetAlert.confirm_alert_eliminar_cita ? (
                        <SweetAlert
                            title="¿Desea borrar la cita?"
                            warning
                            showCancel
                            confirmBtnText="Continuar"
                            confirmBtnBsStyle="success"
                            cancelBtnText="Cancelar"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => borrarCita()}
                            onCancel={() => {
                                setAutoPause(false);
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                                setCitaSeleccionada({
                                    start: formatDate(new Date(), true),
                                    end: formatDate(new Date(new Date().getTime() + tiempoCita), true),
                                });
                                setLoading(false);
                                LimpiarDatos();
                                setAutoPause(false);
                            }}>
                            Se borrará la cita
                        </SweetAlert>
                    ) : null}
                    
                    {confirmaSobreEscribirCita ? (
                        <SweetAlert
                            title="La cita cambió en otra sesión"
                            warning
                            showCancel
                            showConfirm={false}
                            cancelBtnText="Volver a edición"
                            cancelBtnBsStyle="danger"
                            onCancel={async () => {
                                await recargarCitaPorConflictoComentarios();
                            }}>
                            {mensajeSobreEscribirCita}
                        </SweetAlert>
                    ) : null}                    
                    
                    {UISweetAlert.confirm_imprimir_agenda ? (
                        <SweetAlert
                            title={
                                checkFechaFinalImpresion()
                                    ? "Por favor, seleccione el rango de fechas a imprimir"
                                    : "Por favor, seleccione el día a imprimir"
                            }
                            showCancel
                            confirmBtnText="Imprimir"
                            confirmBtnBsStyle="success"
                            cancelBtnText="Cancelar"
                            cancelBtnBsStyle="danger"
                            closeOnClickOutside={false}
                            style={{
                                width: width && width < 851 ? "100%" : "70%",
                            }}
                            onConfirm={() => confirmImprimirAgenda()}
                            onCancel={() => {
                                setAutoPause(false);
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                            }}>
                            <Row className="form-group mt-6">
                                <label className={checkFechaFinalImpresion() ? "col-sm-2 col-form-label" : "col-sm-4 col-form-label"}>
                                    {checkFechaFinalImpresion() ? "Fecha Inicial" : "Fecha"}
                                    <span className="text-xs text-red-700">*</span>
                                </label>
                                <Col sm={checkFechaFinalImpresion() ? 4 : 7}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaImpresion"
                                        onChange={onChangeFiltroImpresion}
                                        value={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                    />
                                    {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                                        <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                    )}
                                </Col>
                                {checkFechaFinalImpresion() ? (
                                    <>
                                        <label className="col-sm-2 col-form-label">
                                            Fecha Final<span className="text-xs text-red-700">*</span>
                                        </label>
                                        <Col sm={4}>
                                            <input
                                                type="date"
                                                autoComplete="off" 
                                                min={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                                className="form-control"
                                                name="fechaImpresionFinal"
                                                onChange={onChangeFiltroImpresion}
                                                value={filtrosImpresion.fechaImpresionFinal ? filtrosImpresion.fechaImpresionFinal : ""}
                                            />
                                            {/* {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                    <span className="text-sm text-red-700">Este campo es obligatorio</span>
                  )} */}
                                        </Col>
                                    </>
                                ) : null}
                            </Row>
                            <Row className="form-group mt-6">
                                {!esMedicoNoAdministrador || esMedicoConRoleAgenda ? (
                                    <>
                                        <label className="col-sm-3 col-form-label">Agenda de todo el día</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                name="porDia"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.porDia}
                                                value={filtrosImpresion.porDia}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {/* Tambien checar si hay algun espacio seleccionado de tipo médico */}

                                {usuario &&
                                (usuario.authorities.includes("ROLE_RECEPCION") ||
                                    usuario.authorities.includes("ROLE_AGENDA") ||
                                    usuario.authorities.includes("ROLE_ADMIN_SISTEMA")) &&
                                checkIncluyeEspacioMedico() ? (
                                    <>
                                        <label className="col-sm-2 col-form-label">Incluir citas</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                name="incluirCitas"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirCitas}
                                                // value={filtrosImpresion.incluirCitas}
                                            />
                                        </Col>
                                        <label className="col-sm-2 col-form-label">Incluir tratamientos</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                name="incluirTratamientos"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirTratamientos}
                                                // value={filtrosImpresion.incluirTratamientos}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {}
                            </Row>
                        </SweetAlert>
                    ) : null}

                    {UISweetAlert.confirm_exponer_agendaGeneral ? (
                        <SweetAlert
                            title="Por favor, seleccione el día a visualizar en sus datos generales"
                            showCancel
                            confirmBtnText="Visualizar"
                            confirmBtnBsStyle="success"
                            cancelBtnText="Cancelar"
                            cancelBtnBsStyle="danger"
                            closeOnClickOutside={false}
                            style={{
                                width: width && width < 851 ? "100%" : "70%",
                            }}
                            onConfirm={() => visualizarCitasGeneral()}
                            onCancel={() => {
                                setAutoPause(false);
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                            }}>
                            <Row className="form-group mt-6">
                                <label className={checkFechaFinalImpresion() ? "col-sm-2 col-form-label" : "col-sm-4 col-form-label"}>
                                    {checkFechaFinalImpresion() ? "Fecha Inicial" : "Fecha"}
                                    <span className="text-xs text-red-700">*</span>
                                </label>
                                <Col sm={checkFechaFinalImpresion() ? 4 : 7}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaImpresion"
                                        onChange={onChangeFiltroImpresion}
                                        value={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                    />
                                    {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                                        <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                    )}
                                </Col>
                                {checkFechaFinalImpresion() ? (
                                    <>
                                        <label className="col-sm-2 col-form-label">
                                            Fecha Final<span className="text-xs text-red-700">*</span>
                                        </label>
                                        <Col sm={4}>
                                            <input
                                                type="date"
                                                autoComplete="off" 
                                                min={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                                className="form-control"
                                                name="fechaImpresionFinal"
                                                onChange={onChangeFiltroImpresion}
                                                value={filtrosImpresion.fechaImpresionFinal ? filtrosImpresion.fechaImpresionFinal : ""}
                                            />
                                            {/* {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                    <span className="text-sm text-red-700">Este campo es obligatorio</span>
                  )} */}
                                        </Col>
                                    </>
                                ) : null}
                            </Row>
                            <Row className="form-group mt-6">
                                {!esMedicoNoAdministrador || esMedicoConRoleAgenda ? (
                                    <>
                                        <label hidden = {true} className="col-sm-3 col-form-label">Agenda de todo el día</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                name="porDia"
                                                hidden = {true}
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.porDia}
                                                value={filtrosImpresion.porDia}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {/* Tambien checar si hay algun espacio seleccionado de tipo médico */}

                                {usuario &&
                                (usuario.authorities.includes("ROLE_RECEPCION") ||
                                    usuario.authorities.includes("ROLE_AGENDA") ||
                                    usuario.authorities.includes("ROLE_ADMIN_SISTEMA")) &&
                                checkIncluyeEspacioMedico() ? (
                                    <>
                                        <label hidden = {true} className="col-sm-2 col-form-label">Incluir citas</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                hidden = {true}
                                                name="incluirCitas"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirCitas}
                                                // value={filtrosImpresion.incluirCitas}
                                            />
                                        </Col>
                                        <label hidden = {true} className="col-sm-2 col-form-label">Incluir tratamientos</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                hidden = {true}
                                                className="form-control"
                                                name="incluirTratamientos"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirTratamientos}
                                                // value={filtrosImpresion.incluirTratamientos}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {}
                            </Row>
                        </SweetAlert>
                    ) : null}                       

                    {UISweetAlert.confirm_exponer_agenda ? (
                        <SweetAlert
                            title="Por favor, seleccione el día a visualizar"
                            showCancel
                            confirmBtnText="Visualizar"
                            confirmBtnBsStyle="success"
                            cancelBtnText="Cancelar"
                            cancelBtnBsStyle="danger"
                            closeOnClickOutside={false}
                            style={{
                                width: width && width < 851 ? "100%" : "70%",
                            }}
                            onConfirm={() => visualizarCitas()}
                            onCancel={() => {
                                setAutoPause(false);
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                            }}>
                            <Row className="form-group mt-6">
                                <label className={checkFechaFinalImpresion() ? "col-sm-2 col-form-label" : "col-sm-4 col-form-label"}>
                                    {checkFechaFinalImpresion() ? "Fecha Inicial" : "Fecha"}
                                    <span className="text-xs text-red-700">*</span>
                                </label>
                                <Col sm={checkFechaFinalImpresion() ? 4 : 7}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaImpresion"
                                        onChange={onChangeFiltroImpresion}
                                        value={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                    />
                                    {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                                        <span className="text-sm text-red-700">Este campo es obligatorio</span>
                                    )}
                                </Col>
                                {checkFechaFinalImpresion() ? (
                                    <>
                                        <label className="col-sm-2 col-form-label">
                                            Fecha Final<span className="text-xs text-red-700">*</span>
                                        </label>
                                        <Col sm={4}>
                                            <input
                                                type="date"
                                                autoComplete="off" 
                                                min={filtrosImpresion.fechaImpresion ? filtrosImpresion.fechaImpresion : ""}
                                                className="form-control"
                                                name="fechaImpresionFinal"
                                                onChange={onChangeFiltroImpresion}
                                                value={filtrosImpresion.fechaImpresionFinal ? filtrosImpresion.fechaImpresionFinal : ""}
                                            />
                                            {/* {(filtrosImpresion.fechaImpresion == "" || !filtrosImpresion.fechaImpresion) && (
                    <span className="text-sm text-red-700">Este campo es obligatorio</span>
                  )} */}
                                        </Col>
                                    </>
                                ) : null}
                            </Row>
                            <Row className="form-group mt-6">
                                {!esMedicoNoAdministrador || esMedicoConRoleAgenda ? (
                                    <>
                                        <label hidden = {true} className="col-sm-3 col-form-label">Agenda de todo el día</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                name="porDia"
                                                hidden = {true}
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.porDia}
                                                value={filtrosImpresion.porDia}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {/* Tambien checar si hay algun espacio seleccionado de tipo médico */}

                                {usuario &&
                                (usuario.authorities.includes("ROLE_RECEPCION") ||
                                    usuario.authorities.includes("ROLE_AGENDA") ||
                                    usuario.authorities.includes("ROLE_ADMIN_SISTEMA")) &&
                                checkIncluyeEspacioMedico() ? (
                                    <>
                                        <label hidden = {true} className="col-sm-2 col-form-label">Incluir citas</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                className="form-control"
                                                hidden = {true}
                                                name="incluirCitas"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirCitas}
                                                // value={filtrosImpresion.incluirCitas}
                                            />
                                        </Col>
                                        <label hidden = {true} className="col-sm-2 col-form-label">Incluir tratamientos</label>
                                        <Col sm={1}>
                                            <input
                                                type="checkbox"
                                                autoComplete="off" 
                                                hidden = {true}
                                                className="form-control"
                                                name="incluirTratamientos"
                                                onChange={onChangeFiltroImpresion}
                                                checked={filtrosImpresion.incluirTratamientos}
                                                // value={filtrosImpresion.incluirTratamientos}
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                {}
                            </Row>
                        </SweetAlert>
                    ) : null}                    

                    {UISweetAlert.confirm_historico_paciente ? (
                        <SweetAlert
                            title="Por favor, seleccione un paciente para ver su historial"
                            confirmBtnText="Cerrar"
                            confirmBtnBsStyle="danger"
                            style={{
                                width: width && width < 851 ? "100%" : "65%",
                                maxHeight: "90vh",
                                overflow: "visible",
                            }}
                            onConfirm={() => {
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                                setPacienteSeleccionadoHistorico(null);
                                setCitasPaciente([]);
                                setAutoPause(false);
                            }}> 
                            <Row >
                                <label className="col-sm-2 col-form-label">
                                    Paciente<span className="text-xs text-red-700">*</span>
                                </label>
                                <Col sm={6}>
                                    <SelectPacientesPaginado
                                        opcionSeleccionadaCompleta={pacienteSeleccionadoHistorico}
                                        onChangeOptions={changePacienteHistorico}
                                        fetchOptions={loadPacientesSelect}
                                        opcionesPaginado={opcionesSelectPacientes.opcionesPaginado}
                                        placeholderText={opcionesSelectPacientes.placeholderText}
                                        optionLabel={opcionesSelectPacientes.optionLabel}
                                        optionValue={opcionesSelectPacientes.optionValue}
                                        isDisabled={!autorizadoHistorico}
                                        width="60%"
                                        isMulti={false}
                                        opcionesExtra={{
                                            menuPortalTarget: document.body,
                                            menuPosition: "fixed",
                                            menuPlacement: "auto",
                                            menuShouldScrollIntoView: false,
                                            maxMenuHeight: 240,
                                            styles: {
                                                menuPortal: (base) => ({...base, zIndex: 99999}),
                                                menu: (base) => ({...base, zIndex: 99999}),
                                            },
                                        }}
                                    />
                                </Col>
                                <Col sm={3}>
                                 
                                    {pacienteSeleccionadoHistorico && citasPaciente && citasPaciente.length > 0 ? (
                                        <DrawerHistoricoCitas citasPaciente={citasPaciente} paciente={pacienteSeleccionadoHistorico}/>
                                    ) : pacienteSeleccionadoHistorico ? (
                                        "El paciente seleccionado no tiene citas"
                                    ) : null}      
                                 </Col>                                
                                    {/* <WindowedSelect
                    isSearchable
                    options={pacientes}
                    getOptionLabel={(option) => `${option.nombres} ${option.apellidoPaterno} ${option.apellidoMaterno}`}
                    getOptionValue={(option) => option}
                    // styles={colourStyles}
                    isClearable
                    value={pacientes.filter((paciente) =>
                      pacienteSeleccionadoHistorico ? paciente.idCatPaciente == pacienteSeleccionadoHistorico.idCatPaciente : ""
                    )}
                    menuPortalTarget={document.body}
                    menuPosition={"fixed"}
                    onChange={(option) => changePacienteHistorico(option)}
                    noOptionsMessage={() => "No hay opciones"}
                    placeholder="Seleccione un paciente"
                  /> */}

                                
                            </Row>


                        </SweetAlert>
                    ) : null}

                    {UISweetAlert.confirm_alert_cita_no_autorizado ? (
                        <SweetAlert
                            error
                            title={UISweetAlert.dynamic_title}
                            onConfirm={() =>
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                })
                            }>
                            No tienes los permisos necesarios para crear una cita.
                        </SweetAlert>
                    ) : null}

                    {UISweetAlert.success_dlg ? (
                        <SweetAlert
                            success
                            title={UISweetAlert.dynamic_title}
                            onConfirm={() => {
                                if (UISweetAlert.redirect) {
                                    props.history.push(UISweetAlert.path);
                                }
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                });
                            }}>
                            {UISweetAlert.dynamic_description}
                        </SweetAlert>
                    ) : null}

                    {UISweetAlert.error_dlg ? (
                        <SweetAlert
                            error
                            title={UISweetAlert.dynamic_title}
                            onConfirm={() =>
                                setUISweetAlert({
                                    ...sweetAlertDefault,
                                    confirm_alert_cita: UISweetAlert.confirm_alert_cita,
                                    editar: UISweetAlert.editar,
                                })                                
                            }>
                            {UISweetAlert.dynamic_description}
                        </SweetAlert>
                    ) : null}

                    {loading ? (
                        <SweetAlert title="Cargando!" onConfirm={() => {
                        }} showConfirm={false}>
                            <Spinner/>
                            {/* {UISweetAlert.dynamic_description ? UISweetAlert.dynamic_description : ""} */}
                        </SweetAlert>
                    ) : null}
                </>
            ) : null}       
        </>
    );

    function checkFechaFinalImpresion() {
        return (
            !opcionesExtras.seleccionarTodosEspacios &&
            filtroCitasEspacios &&
            filtroCitasEspacios.length > 0 &&
            !filtrosImpresion.porDia
        );
    }

    function filterPacienteCitaSeleccionada(idCatPaciente) {
        let pacienteCompletoCita = null;

        const posicionPacienteDeCita = pacientes
        .map(function (x) {
            return x.idCatPaciente;
        })
        .indexOf(idCatPaciente);

        if (posicionPacienteDeCita >= 0) {
            pacienteCompletoCita = pacientes[posicionPacienteDeCita];

            setPacienteDeCitaSeleccionada(pacienteCompletoCita);
        } else {
            setPacienteDeCitaSeleccionada(null);
        }
        return pacienteCompletoCita;
    }

    function checkIfMedico() {
        return async () => {
          setAutoPause(true);
          setLoading(true);
          let espaciosFetched = null;
          espaciosFetched = await listarEspaciosAtencionAgenda(true);
      
          let espaciosDefault;
          if (espaciosFetched && espaciosFetched.length > 0) {
            espaciosDefault = await seleccionarEspaciosAtencionDefault(espaciosFetched);
          }
      
          if ((esMedicoNoAdministrador && !esMedicoConRoleAgenda) || esAsistente) {
            // === rama 1: médico (sin role agenda) o asistente ===
            const espacios = (espaciosDefault && espaciosDefault.length > 0) ? espaciosDefault : [];
            checkHorarioEspacio(espacios);
            try {
              let temporal = false;
              if (esMedico || esAsistente) {
                temporal = opcionesExtras.seleccionarTodosEspacios;
                opcionesExtras.seleccionarTodosEspacios = false;
              }
      
              // === 3B: sincroniza rango/filtros para el timer ===
              const { viewStart, viewEnd } =
                (typeof getViewRange === "function" && getViewRange()) || {
                  viewStart: filtrosRef.current.viewStart,
                  viewEnd:   filtrosRef.current.viewEnd,
                };
      
              filtrosRef.current = {
                viewStart,
                viewEnd,
                espaciosVo: espacios || [],
                pacientesVo: filtroCitasPacientes || [],
                aseguradorasVo: filtroCitasAseguradoras || [],
                todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
                todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
                porAseguradora: !!opcionesExtras.porAseguradora,
                incluirTratamientos: false,
                incluirCitas: false,
              };
              // ================================================
      
              await listarCitas(
                fechaActual,
                espacios,
                filtroCitasPacientes,
                filtroCitasAseguradoras,
                opcionesExtras.seleccionarTodosEspacios,
                opcionesExtras.seleccionarTodosPacientes,
                opcionesExtras.porAseguradora
              );
      
              if (esMedico || esAsistente) {
                opcionesExtras.seleccionarTodosEspacios = temporal;
              }
      
              await delay(delayTime);
              setLoading(false);
              setAutoPause(false);
            } catch (error) {
              setLoading(false);
              setAutoPause(false);
            }
      
          } else if (esMedicoConRoleAgenda && usuario.idCatMedico != null) {
            // === rama 2: médico con role agenda ===
            const espacios = (espaciosDefault && espaciosDefault.length > 0) ? espaciosDefault : [];
            checkHorarioEspacio(espacios);
            setFiltroCitasEspacios(espacios);
            try {
              let temporal = false;
              if (esMedico || esAsistente) {
                temporal = opcionesExtras.seleccionarTodosEspacios;
                opcionesExtras.seleccionarTodosEspacios = false;
              }
      
              // === 3B: sincroniza rango/filtros para el timer ===
              const { viewStart, viewEnd } =
                (typeof getViewRange === "function" && getViewRange()) || {
                  viewStart: filtrosRef.current.viewStart,
                  viewEnd:   filtrosRef.current.viewEnd,
                };
      
              filtrosRef.current = {
                viewStart,
                viewEnd,
                espaciosVo: espacios || [],
                pacientesVo: filtroCitasPacientes || [],
                aseguradorasVo: filtroCitasAseguradoras || [],
                todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
                todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
                porAseguradora: !!opcionesExtras.porAseguradora,
                incluirTratamientos: false,
                incluirCitas: false,
              };
              // ================================================
      
              await listarCitas(
                fechaActual,
                espacios,
                filtroCitasPacientes,
                filtroCitasAseguradoras,
                opcionesExtras.seleccionarTodosEspacios,
                opcionesExtras.seleccionarTodosPacientes,
                opcionesExtras.porAseguradora
              );
      
              if (esMedico || esAsistente) {
                opcionesExtras.seleccionarTodosEspacios = temporal;
              }
      
              await delay(delayTime);
              setLoading(false);
              setAutoPause(false);
            } catch (error) {
              setLoading(false);
              setAutoPause(false);
            }
      
          } else if (filtroCitasEspacios != null) {
            // === rama 3: espacios ya en filtro ===
            checkHorarioEspacio(filtroCitasEspacios);
            try {
              let temporal = false;
              if (esMedico || esAsistente) {
                temporal = opcionesExtras.seleccionarTodosEspacios;
                opcionesExtras.seleccionarTodosEspacios = false;
              }
      
              // === 3B: sincroniza rango/filtros para el timer ===
              const { viewStart, viewEnd } =
                (typeof getViewRange === "function" && getViewRange()) || {
                  viewStart: filtrosRef.current.viewStart,
                  viewEnd:   filtrosRef.current.viewEnd,
                };
      
              filtrosRef.current = {
                viewStart,
                viewEnd,
                espaciosVo: filtroCitasEspacios || [],
                pacientesVo: filtroCitasPacientes || [],
                aseguradorasVo: opcionesAseguradoras || [],
                todosEspacios: !!opcionesExtras.seleccionarTodosEspacios,
                todosPacientes: !!opcionesExtras.seleccionarTodosPacientes,
                porAseguradora: !!opcionesExtras.porAseguradora,
                incluirTratamientos: false,
                incluirCitas: false,
              };
              // ================================================
      
              await listarCitas(
                fechaActual,
                filtroCitasEspacios,
                filtroCitasPacientes,
                opcionesAseguradoras,
                opcionesExtras.seleccionarTodosEspacios,
                opcionesExtras.seleccionarTodosPacientes,
                opcionesExtras.porAseguradora
              );
      
              if (esMedico || esAsistente) {
                opcionesExtras.seleccionarTodosEspacios = temporal;
              }
      
              await delay(delayTime);
              setLoading(false);
              setAutoPause(false);
            } catch (error) {
              setLoading(false);
              setAutoPause(false);
            }
          }
      
          setLoading(false);
          setAutoPause(false);
        };
    }
      
}
// <FullCalendar
//   // eventContent={renderEventContent}
//   timeZone="America/Mexico_City"
//   plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
//   ref={calendarComponentRef}
//   initialView="timeGridWeek"
//   navLinks={true}
//   nowIndicator={true}
//   progressiveEventRendering={false}
//   dayMaxEventRows={5}
//   eventMaxStack={2}
//   editable={true}
//   eventDrop={cambioHoraCita}
//   eventResize={cambioHoraCita}
//   slotMinTime={horarioMinimoCalendario ? horarioMinimoCalendario : "06:00:00"}
//   slotMaxTime={"23:45:00"}
//   slotDuration={"00:15:00"}
//   allDaySlot={false}
//   weekends={mostrarFinDeSemana}
//   eventSources={[
//     {
//       events: citas,
//       color: "#000000",
//       // color: 'green',
//     },
//   ]}
//   headerToolbar={{
//     left: "prev,next today nuevoEvento nuevoPaciente",
//     center: "title",
//     right: "dayGridMonth,timeGridWeek,timeGridDay",
//   }}
//   buttonText={{
//     today: "Hoy",
//     month: "Mes",
//     week: "Semana",
//     day: "Día",
//   }}
//   customButtons={{
//     nuevoEvento: {
//       text: "Nueva Cita",
//       click: () => {
//         checkPermisosCalendario();
//       },
//     },
//     nuevoPaciente: {
//       text: "Nuevo Paciente",
//       click: () => {
//         nuevoPacienteRedirect();
//       },
//     },
//   }}
//   initialDate={formatDate(new Date(), true)}
//   dateClick={autorizado ? nuevaCitaFechaSeleccionada : null}
//   eventClick={editCitaConfirm}
//   viewDidMount={viewchange}
//   datesSet={(info) => changeFecha(info)}
//   locale="es"
// />;



